export const quizData = {
  // ==========================================
  // 1. 바로크 작곡가 (Baroque_composer.txt)
  // ==========================================
  "gabrieli": [
    {
      "question": "조반니 가브리엘리가 활동했던 성당이자, 오르간 주자로 재직했던 장소는 어디인가요?",
      "options": ["로마 성 베드로 대성당", "베네치아 산마르코 대성당", "뤼베크 마리아 교회", "파리 노트르담 대성당"],
      "answer": 1,
      "explanation": "조반니 가브리엘리는 베네치아 산마르코 대성당의 오르간 주자이자 작곡가였습니다."
    },
    {
      "question": "조반니 가브리엘리가 완성한 양식으로, 두 개의 합창단이 공간적으로 분리되어 교창하는 음악 양식은 무엇인가요?",
      "options": ["모노디 양식", "복합창 양식", "갈랑 양식", "감정과다 양식"],
      "answer": 1,
      "explanation": "가브리엘리는 두 개의 합창단이 공간적으로 분리되어 교창하는 복합창 양식을 완성했습니다."
    },
    {
      "question": "가브리엘리는 성악과 대등하게 '이것'을 사용한 선구자로, 바로크 기악 음악의 출발점을 열었습니다. '이것'은 무엇인가요?",
      "options": ["기악", "무용", "독백", "전자음향"],
      "answer": 0,
      "explanation": "가브리엘리는 성악과 대등하게 기악을 사용한 선구자입니다."
    },
    {
      "question": "가브리엘리의 음악을 배워 바로크 양식을 독일로 전파한 핵심 제자는 누구인가요?",
      "options": ["디트리히 북스테후데", "하인리히 쉬츠", "요한 제바스티안 바흐", "게오르크 필리프 텔레만"],
      "answer": 1,
      "explanation": "그의 음악을 배운 독일의 하인리히 쉬츠를 통해 바로크 양식이 독일로 전파되었습니다."
    },
    {
      "question": "조반니 가브리엘리는 어느 음악 시대의 출발점을 열었다고 평가받나요?",
      "options": ["르네상스 기악 음악", "바로크 기악 음악", "고전주의 교향곡", "낭만주의 표제 음악"],
      "answer": 1,
      "explanation": "가브리엘리는 바로크 기악 음악의 출발점을 연 선구자입니다."
    }
  ],
  "peri": [
    {
      "question": "자코모 페리가 작곡한 작품으로, 현존하는 가장 오래된 오페라의 제목은 무엇인가요?",
      "options": ["오르페오", "다프네", "에ורי디체", "디도와 에네아스"],
      "answer": 2,
      "explanation": "자코모 페리는 현존하는 가장 오래된 오페라 '에ורי디체(1600)'의 작곡가입니다."
    },
    {
      "question": "자코모 페리는 어떤 모임의 원칙을 실현하여 오페라라는 장르를 탄생시켰나요?",
      "options": ["피렌체 카메라타", "제2 빈악파", "만하임 악파", "인상주의 학파"],
      "answer": 0,
      "explanation": "자코모 페리는 피렌체 카메라타의 모노디 원칙을 실현하여 오페라 장르를 탄생시켰습니다."
    },
    {
      "question": "자코모 페리가 오페라 장르를 탄생시키기 위해 실현했던 음악적 원칙은 무엇인가요?",
      "options": ["대위법 원칙", "모노디 원칙", "12음 기법 원칙", "총렬주의 원칙"],
      "answer": 1,
      "explanation": "자코모 페리는 피렌체 카메라타의 '모노디 원칙'을 실현했습니다."
    },
    {
      "question": "자코모 페리의 오페라 '에ורי디체'에 대한 역사적 평가로 올바른 것은 무엇인가요?",
      "options": ["음악적 완성도가 완벽한 최고 걸작이다", "최초로 대규모 금관악기를 도입했다", "음악적 완성도는 낮지만 역사적인 오페라의 출발점이다", "신화가 아닌 역사적 인물을 최초로 다루었다"],
      "answer": 2,
      "explanation": "에ורי디체는 음악적으로 완성도는 낮지만 역사적으로 오페라의 출발점이라는 점에서 의미가 큽니다."
    },
    {
      "question": "자코모 페리가 활동한 주요 국가는 어디인가요?",
      "options": ["독일", "프랑스", "이탈리아", "영국"],
      "answer": 2,
      "explanation": "자코모 페리는 이탈리아의 작곡가입니다."
    }
  ],
  "monteverdi": [
    {
      "question": "르네상스 폴리포니와 바로크 모노디를 동시에 구사하며 바로크 음악을 실질적으로 연 작곡가는 누구인가요?",
      "options": ["클라우디오 몬테베르디", "자코모 페리", "장바티스트 륄리", "아르칸젤로 코렐리"],
      "answer": 0,
      "explanation": "클라우디오 몬테베르디는 바로크 음악을 실질적으로 연 인물입니다."
    },
    {
      "question": "몬테베르디가 개척한 두 가지 양식으로 올바르게 짝지어진 것은 무엇인가요?",
      "options": ["갈랑 양식과 감정과다 양식", "프리마 프락티카(구양식)와 세콘다 프락티카(신양식)", "인상주의와 표현주의 양식", "원시주의와 신고전주의 양식"],
      "answer": 1,
      "explanation": "몬테베르디는 프리마 프락티카(구양식)와 세콘다 프락티카(신양식)를 개척했습니다."
    },
    {
      "question": "극적 표현과 오케스트라 사용이 혁명적이었던, 몬테베르디의 초기 오페라 최고 걸작은 무엇인가요?",
      "options": ["에ורי디체", "오르페오", "다프네", "디도와 에네아스"],
      "answer": 1,
      "explanation": "오페라 오르페오(1607)는 초기 오페라 최고 걸작으로 꼽힙니다."
    },
    {
      "question": "몬테베르디의 말년작으로, 오페라 역사상 최초로 신화가 아닌 '역사적 인물'을 소재로 삼은 작품은 무엇인가요?",
      "options": ["오르페오", "포페아의 대관식", "시녀 마님", "피터 그라임스"],
      "answer": 1,
      "explanation": "말년작 '포페아의 대관식'은 오페라 역사상 최초로 역사적 인물을 소재로 삼았습니다."
    },
    {
      "question": "몬테베르디가 분노와 긴장을 음악으로 표현하기 위해 최초로 도입한 현악기 연주 기법은 무엇인가요?",
      "options": ["피치카토", "현악 트레몰로", "글리스앤도", "스코르다투라"],
      "answer": 1,
      "explanation": "몬테베르디는 현악 트레몰로를 처음 사용해 분노와 긴장을 음악으로 표현하는 방식을 개척했습니다."
    }
  ],
  "frescobaldi": [
    {
      "question": "바로크 초기 최고의 건반악기 작곡가로 꼽히며 로마 성 베드로 대성당의 오르가니스트로 재직한 인물은 누구인가요?",
      "options": ["디트리히 북스테후데", "지롤라모 프레스코발디", "프랑수아 쿠프랭", "장필리프 라모"],
      "answer": 1,
      "explanation": "지롤라모 프레스코발디는 로마 성 베드로 대성당의 오르가니스트였습니다."
    },
    {
      "question": "다음 중 프레스코발디가 발전시킨 건반악기 장르가 아닌 것은 무엇인가요?",
      "options": ["토카타", "판타지아", "리체르카레", "표제 교향곡"],
      "answer": 3,
      "explanation": "프레스코발디는 토카타, 판타지아, 리체르카레 등의 건반악기 장르를 발전시켰습니다."
    },
    {
      "question": "프레스코발디의 연주 및 작곡 스타일에서 가장 중시되었던 요소는 무엇인가요?",
      "options": ["철저하고 엄격한 규칙 준수", "연주자의 자유로운 감정 표현과 즉흥성", "대규모 오케스트라와의 정교한 협연", "체제에 대한 순응과 풍자"],
      "answer": 1,
      "explanation": "프레스코발디는 연주자의 자유로운 감정 표현과 즉흥성을 중시한 선구자였습니다."
    },
    {
      "question": "이탈리아에서 프레스코발디와 견줄 건반악기 작곡가가 없었다고 평가받는 기간은 약 몇 년간인가요?",
      "options": ["10여 년간", "50여 년간", "100여 년간", "200여 년간"],
      "answer": 2,
      "explanation": "본문 데이터에 따르면 이후 100여 년간 이탈리아에서 그와 견줄 건반악기 작곡가가 없었다는 평가를 받습니다."
    },
    {
      "question": "프레스코발디가 직접적인 영향을 미쳤다고 명시된 후대의 대표적인 건반 작곡가는 누구인가요?",
      "options": ["요한 제바스티안 바흐", "볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "프레데리크 쇼پن"],
      "answer": 0,
      "explanation": "프레스코발디는 바흐를 비롯한 후대 건반 작곡가 전체에 직접적 영향을 미쳤습니다."
    }
  ],
  "schutz": [
    {
      "question": "이탈리아 바로크 양식을 독일에 이식하여 '독일 바로크 음악의 아버지'로 불리는 작곡가는 누구인가요?",
      "options": ["하인리히 쉬츠", "디트리히 북스테후데", "요한 제바스티안 바흐", "요한 슈타미츠"],
      "answer": 0,
      "explanation": "하인리히 쉬츠는 독일 바로크 음악의 아버지로 불립니다."
    },
    {
      "question": "하인리히 쉬츠가 이탈리아 베네치아에서 직접 사사한 스승은 누구인가요?",
      "options": ["자코모 페리", "조반니 가브리엘리", "아르칸젤로 코렐리", "안토니오 비발디"],
      "answer": 1,
      "explanation": "하인리히 쉬츠는 베네치아에서 조반니 가브리엘리에게 직접 사사했습니다."
    },
    {
      "question": "하인리히 쉬츠가 남긴 작품으로, '독일 최초의 오페라'라는 타이틀을 가진 작품은 무엇인가요?",
      "options": ["에ורי디체", "다프네", "오르페오", "디도와 에네아스"],
      "answer": 1,
      "explanation": "독일 최초의 오페라 다프네(1627)는 하인리히 쉬츠의 작품입니다."
    },
    {
      "question": "하인리히 쉬츠가 뛰어난 작품을 남긴 주요 음악 장르가 아닌 것은 무엇인가요?",
      "options": ["수난곡", "오라토리오", "독일어 종교 음악", "건반 소나타 555곡"],
      "answer": 3,
      "explanation": "쉬츠는 수난곡, 오라토리오, 독일어 종교 음악에서 뛰어난 작품을 남겼습니다. 건반 소나타 555곡은 스카를라티의 업적입니다."
    },
    {
      "question": "하인리히 쉬츠는 누구로 이어지는 독일 프로테스탄트 음악 전통의 직접적 선조인가요?",
      "options": ["루트비히 판 베토벤", "요한 제바스티안 바흐", "볼프강 아마데우스 모차르트", "요하네스 브람스"],
      "answer": 1,
      "explanation": "쉬츠는 바흐로 이어지는 독일 프로테스탄트 음악 전통의 직접적 선조입니다."
    }
  ],
  "lully": [
    {
      "question": "장바티스트 륄리는 어느 프랑스 왕의 전속 작곡가로 활동하며 프랑스 오페라와 발레의 기초를 세웠나요?",
      "options": ["루이 14세", "루이 16세", "나폴레옹 1세", "샤를 10세"],
      "answer": 0,
      "explanation": "장바티스트 륄리는 루이 14세의 전속 작곡가였습니다."
    },
    {
      "question": "장바티스트 륄리가 확립한 오케스트라 편성의 특징은 무엇을 중심으로 하나요?",
      "options": ["관악기 중심", "타악기 중심", "현악기 중심", "성악 중심"],
      "answer": 2,
      "explanation": "륄리는 현악 중심의 오케스트라 편성을 확립했습니다."
    },
    {
      "question": "장바티스트 륄리가 창안한 프랑스풍 서곡 형식의 구조로 올바른 것은 무엇인가요?",
      "options": ["빠름-느림-빠름", "느림-빠름-느림", "느림-느림-빠름", "빠름-빠름-느림"],
      "answer": 1,
      "explanation": "륄리는 느림-빠름-느림 구조의 프랑스풍 서곡 형식을 창안했습니다."
    },
    {
      "question": "장바티스트 륄리는 원래 어느 나라 출신이지만 프랑스 음악의 정체성을 만들어냈나요?",
      "options": ["독일", "오스트리아", "이탈리아", "영국"],
      "answer": 2,
      "explanation": "륄리는 이탈리아 출신이지만 프랑스 오페라와 발레의 기초를 세웠습니다."
    },
    {
      "question": "장바티스트 륄리의 사망 원인과 관련된 독특한 일화는 무엇인가요?",
      "options": ["청력을 완전히 상실하여 우울증으로 사망", "지휘 도중 긴 지팡이로 자신의 발을 찍은 부상으로 사망", "독살당했다는 설이 유력함", "기차 사고로 사망"],
      "answer": 1,
      "explanation": "륄리는 긴 지팡이로 박자를 치다가 자신의 발을 찍어 그 부상으로 사망한 일화가 유명합니다."
    }
  ],
  "carissimi": [
    {
      "question": "무대 장치 없이 독창·합창·오케스트라로만 종교 이야기를 표현하는 '이 장르'를 확립한 이탈리아 작곡가는 누구인가요?",
      "options": ["야코포 카리시미", "자코모 페리", "아르칸젤로 코렐리", "하인리히 쉬츠"],
      "answer": 0,
      "explanation": "야코포 카리시미는 오라토리오 장르를 확립한 작곡가입니다."
    },
    {
      "question": "오라토리오 형식을 완성한 카리시미가 남긴 대표작 두 편은 무엇인가요?",
      "options": ["오르페오와 다프네", "에ורי디체와 디도와 에네아스", "예프타와 발타자르", "메시아와 사계"],
      "answer": 2,
      "explanation": "카리시미의 대표작으로는 예프타와 발타자르 등이 있습니다."
    },
    {
      "question": "야코포 카리시미가 확립한 오라토리오 장르의 연출적 특징은 무엇인가요?",
      "options": ["화려한 무대 장치와 의상", "무대 장치 없음", "연주자가 연기를 필수로 동반함", "무용수들이 발레를 함께 춤"],
      "answer": 1,
      "explanation": "오라토리오는 무대 장치 없이 독창, 합창, 오케스트라로만 종교 이야기를 표현하는 형식입니다."
    },
    {
      "question": "카리시미가 완성한 오라토리오 형식은 후대 어떤 거장의 오라토리오에 직접적인 영향을 미쳤나요?",
      "options": ["요한 제바스티안 바흐", "게오르크 프리드리히 헨델", "안토니오 비발디", "요제프 하이든"],
      "answer": 1,
      "explanation": "카리시미의 오라토리오는 이후 헨델의 오라토리오에 직접적 영향을 미쳤습니다."
    },
    {
      "question": "야코포 카리시미는 바로크 음악의 세 시기(초기, 중기, 말기) 중 어느 시기에 속하나요?",
      "options": ["초기 바로크", "중기 바로크", "말기 바로크", "전성기 고전주의"],
      "answer": 1,
      "explanation": "카리시미는 '중기 바로크(1630~1680) — 장르와 형식의 확립' 섹션에 포함되어 있습니다."
    }
  ],
  "biber": [
    {
      "question": "바로크 바이올린 음악의 혁신가로 불리는 오스트리아 출신의 작곡가는 누구인가요?",
      "options": ["하인리히 이그나츠 프란츠 비버", "아르칸젤로 코렐리", "안토니오 비발디", "루이지 보케리니"],
      "answer": 0,
      "explanation": "하인리히 이그나츠 프란츠 비버는 바로크 바이올린 음악의 혁신가입니다."
    },
    {
      "question": "하인리히 비버가 창의적으로 활용한 기법으로, '현의 조율을 바꾸는 기법'을 뜻하는 용어는 무엇인가요?",
      "options": ["트레몰로", "피치카토", "스코르다투라", "리토르넬로"],
      "answer": 2,
      "explanation": "스코르다투라는 현의 조율을 바꾸는 기법을 의미합니다."
    },
    {
      "question": "스코르다투라 기법을 창의적으로 활용한 하인리히 비버의 대표작은 무엇인가요?",
      "options": ["미스터리 소나타", "트리오 소나타", "콘체르토 그로소", "브란덴부르크 협주곡"],
      "answer": 0,
      "explanation": "비버의 대표작은 미스터리 소나타 15곡입니다."
    },
    {
      "question": "하인리히 비버의 '미스터리 소나타'는 총 몇 곡으로 구성되어 있나요?",
      "options": ["5곡", "12곡", "15곡", "24곡"],
      "answer": 2,
      "explanation": "미스터리 소나타는 총 15곡이 대표작으로 명시되어 있습니다."
    },
    {
      "question": "하인리히 비버가 음악사적으로 기여한 가장 큰 업적은 무엇인가요?",
      "options": ["현대 교향악단의 금관악기 구조 정립", "바이올린 기법을 확장해 후대 바이올린 음악 발전의 토대 마련", "오페라 부파 장르의 개척", "기능화성 이론의 완성"],
      "answer": 1,
      "explanation": "비버는 바이올린 기법을 전례 없이 확장해 후대 바이올린 음악 발전의 토대를 놓았습니다."
    }
  ],
  "buxtehude": [
    {
      "question": "북독일 오르간 음악의 거장으로, 뤼베크의 마리아 교회 오르가니스트로 재직한 인물은 누구인가요?",
      "options": ["지롤라모 프레스코발디", "디트리히 북스테후데", "요한 제바스티안 바흐", "칼 필리프 에마누엘 바흐"],
      "answer": 1,
      "explanation": "디트리히 북스테후데는 북독일 오르간 음악의 거장으로 뤼베크 마리아 교회에서 재직했습니다."
    },
    {
      "question": "다음 중 디트리히 북스테후데가 발전시킨 음악 장르가 아닌 것은 무엇인가요?",
      "options": ["코랄 판타지", "토카타", "프렐루드", "클라브생 작품"],
      "answer": 3,
      "explanation": "북스테후데는 코랄 판타지, 토카타, 프렐루드를 발전시켰습니다. 클라브생 작품은 쿠프랭의 대표적 장르입니다."
    },
    {
      "question": "젊은 시절의 바흐가 북스테후데의 연주를 직접 듣기 위해 걸어갔던 거리는 대략 얼마였나요?",
      "options": ["약 40km", "약 100km", "약 400km", "약 1000km"],
      "answer": 2,
      "explanation": "젊은 바흐가 그의 연주를 듣기 위해 약 400km를 걸어갔다는 일화가 전해집니다."
    },
    {
      "question": "북스테후데가 오르간 음악에 도입하여 음악적 혁신을 이룬 요소는 무엇인가요?",
      "options": ["스페인 민속 음악의 리듬", "극적 표현", "기계적이고 날카로운 타악 소리", "철저한 무조 음악 체계"],
      "answer": 1,
      "explanation": "북스테후데는 오르간 음악에 극적 표현을 도입한 선구자입니다."
    },
    {
      "question": "디트리히 북스테후데는 후대 어떤 위대한 음악가의 오르간 음악의 직접적 선조인가요?",
      "options": ["볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "요한 제바스티안 바흐", "펠릭스 멘델스존"],
      "answer": 2,
      "explanation": "북스테후데는 바흐 오르간 음악의 직접적 선조입니다."
    }
  ],
  "purcell": [
    {
      "question": "영국 최초의 진정한 오페라로 평가받는 헨리 퍼셀의 대표작은 무엇인가요?",
      "options": ["다프네", "디도와 에네아스", "피터 그라임스", "포페아의 대관식"],
      "answer": 1,
      "explanation": "오페라 '디도와 에네아스'는 헨리 퍼셀이 남긴 영국 최초의 진정한 오페라입니다."
    },
    {
      "question": "오페라 역사상 가장 아름다운 아리아 중 하나로 꼽히는 '디도와 에네아스' 속 아리아의 제목은 무엇인가요?",
      "options": ["할렐루야", "디도의 비가", "달에 홀린 피에로", "법열의 시"],
      "answer": 1,
      "explanation": "'디도와 에네아스'에 등장하는 '디도의 비가'는 가장 아름다운 아리아 중 하나로 꼽힙니다."
    },
    {
      "question": "다음 중 헨리 퍼셀이 영국 음악의 독자적 언어를 만들어낸 장르가 아닌 것은 무엇인가요?",
      "options": ["앤섬", "시나가", "극 부수 음악", "총렬주의 음악"],
      "answer": 3,
      "explanation": "퍼셀은 앤섬, 시나가, 극 부수 음악 등 다양한 장르에서 영국 음악의 독자적 언어를 만들었습니다."
    },
    {
      "question": "헨리 퍼셀이 세상을 떠난 나이는 몇 세였나요?",
      "options": ["26세", "31세", "36세", "45세"],
      "answer": 2,
      "explanation": "헨리 퍼셀은 36세라는 젊은 나이에 요절했습니다."
    },
    {
      "question": "헨리 퍼셀이 요절한 이후, 누구의 등전 전까지 약 200년 이상 퍼셀이 영국 음악의 기준으로 남아있었나요?",
      "options": ["게오르크 프리드리히 헨델", "벤저민 브리튼", "요한 크리스티안 바흐", "안토니오 비발디"],
      "answer": 0,
      "explanation": "퍼셀은 이후 헨델이 등장하기 전까지 200년 이상 영국 음악의 기준으로 남아 있었습니다."
    }
  ],
  "corelli": [
    {
      "question": "바로크 기악 음악의 체계를 완성하고 트리오 소나타와 콘체르토 그로소 형식을 정립한 이탈리아 작곡가는 누구인가요?",
      "options": ["아르칸젤로 코렐리", "안토니오 비발디", "도메니코 스카를라티", "루이지 보케리니"],
      "answer": 0,
      "explanation": "아르칸젤로 코렐리는 트리오 소나타와 콘체르토 그로소 형식을 정립하며 바로크 기악 음악의 체계를 완성했습니다."
    },
    {
      "question": "아르칸젤로 코렐리가 정립한 두 가지 핵심 기악 음악 형식은 무엇인가요?",
      "options": ["독주 소나타와 표제 교향곡", "트리오 소나타와 콘체르토 그로소", "피아노 소나타와 현악 오중주", "프렐루드와 토카타"],
      "answer": 1,
      "explanation": "코렐리는 트리오 소나타와 콘체르토 그로소 형식을 정립했습니다."
    },
    {
      "question": "아르칸젤로 코렐리의 작품들이 지닌 대표적인 양식적 특징은 무엇인가요?",
      "options": ["예측할 수 없는 격정적인 전조", "균형 잡힌 선율과 명확한 화성 진행", "스페인 민속 음악의 적극적 차용", "복잡하고 거대한 복합창의 배치"],
      "answer": 1,
      "explanation": "코렐리의 작품은 균형 잡힌 선율과 명확한 화성 진행으로 유명합니다."
    },
    {
      "question": "코렐리가 체계화하여 현대 '이 악기' 음악의 기초를 마련한 연주 기법은 무엇인가요?",
      "options": ["피아노", "첼로", "오르간", "바이올린"],
      "answer": 3,
      "explanation": "코렐리는 바이올린 연주 기법을 체계화해 현대 바이올린 음악의 기초를 마련했습니다."
    },
    {
      "question": "다음 중 코렐리의 영향을 강력하게 받았다고 본문에 직접 언급되지 않은 작곡가는 누구인가요?",
      "options": ["안토니오 비발디", "게오르크 프리드리히 헨델", "요한 제바스티안 바흐", "클로드 드뷔시"],
      "answer": 3,
      "explanation": "코렐리는 후대 비발디와 헨델, 바흐에게 큰 영향을 주었습니다. 인상주의인 드뷔시와는 무관합니다."
    }
  ],
  "vivaldi": [
    {
      "question": "안토니오 비발디가 가졌던 유명한 별명은 무엇인가요?",
      "options": ["붉은 머리 신부", "피아노의 아버지", "교향곡의 아버지", "런던의 바흐"],
      "answer": 0,
      "explanation": "안토니오 비발디는 '붉은 머리 신부'라는 별명으로 유명했습니다."
    },
    {
      "question": "비발디는 어떤 음악 장르의 형식을 완성한 인물로 평가받나요?",
      "options": ["교향곡 형식", "협주곡 형식", "오라토리오 형식", "오페라 부파 형식"],
      "answer": 1,
      "explanation": "안토니오 비발디는 협주곡 형식을 완성한 인물로 평가받습니다."
    },
    {
      "question": "음악사상 최초의 본격적인 표제 음악 가운데 하나로 꼽히는 비발디의 대표작은 무엇인가요?",
      "options": ["사계", "메시아", "왕궁의 불꽃놀이 음악", "브란덴부르크 협주곡"],
      "answer": 0,
      "explanation": "비발디의 대표작 '사계'는 음악사상 최초의 본격적인 표제 음악 가운데 하나입니다."
    },
    {
      "question": "비발디가 바흐를 비롯한 후대 작곡가들에게 큰 영향을 준 음악적 형식은 무엇인가요?",
      "options": ["모노디 형식", "리토르넬로 형식", "프랑스풍 서곡 형식", "한 악장 소나타 형식"],
      "answer": 1,
      "explanation": "비발디의 리토르넬로 형식은 바흐를 비롯한 후대 작곡가들에게 큰 영향을 주었습니다."
    },
    {
      "question": "비발디가 평생 작곡한 협주곡의 수는 대략 몇 곡 이상인가요?",
      "options": ["100여 곡", "300여 곡", "500여 곡", "3000여 곡"],
      "answer": 2,
      "explanation": "비발디는 500곡이 넘는 협주곡을 작곡했습니다."
    }
  ],
  "couperin": [
    {
      "question": "프랑스 건반 음악의 대표적 거장으로, 우아하고 섬세한 프랑스 양식을 완성한 작곡가는 누구인가요?",
      "options": ["프랑수아 쿠프랭", "장필리프 라모", "장바티스트 륄리", "올리비에 메시앙"],
      "answer": 0,
      "explanation": "프랑수아 쿠프랭은 우아하고 섬세한 프랑스 양식을 완성한 건반 음악의 거장입니다."
    },
    {
      "question": "프랑수아 쿠프랭이 수없이 많이 남긴 건반 악기 작품 종류는 무엇인가요?",
      "options": ["오르간 코랄", "클라브생 작품", "피아노 소나티네", "신디사이저 음악"],
      "answer": 1,
      "explanation": "쿠프랭은 수많은 클라브생 작품을 남겼습니다."
    },
    {
      "question": "쿠프랭이 클라브생 작품을 작곡할 때 음악적 성격을 표현하기 위해 사용한 독특한 방법은 무엇인가요?",
      "options": ["각각의 곡에 독특한 제목을 붙임", "숫자로만 곡을 분류함", "스페인 기타 기법을 가사로 적음", "무조건 한 악장으로만 끝냄"],
      "answer": 0,
      "explanation": "쿠프랭은 각각의 곡에 독특한 제목을 붙여 음악적 성격을 표현했습니다."
    },
    {
      "question": "프랑수아 쿠프랭이 자신의 음악 속에서 서로 결합하고자 노력했던 두 나라의 음악 양식은 무엇인가요?",
      "options": ["독일 음악과 프랑스 음악", "프랑스 음악과 이탈리아 음악", "이탈리아 음악과 영국 음악", "스페인 음악과 러시아 음악"],
      "answer": 1,
      "explanation": "쿠프랭은 프랑스 음악과 이탈리아 음악의 장점을 결합하려고 노력했던 인물입니다."
    },
    {
      "question": "프랑수아 쿠프랭은 주로 어느 나라에서 활동했나요?",
      "options": ["이탈리아", "독일", "영국", "프랑스"],
      "answer": 3,
      "explanation": "프랑수아 쿠프랭은 프랑스의 대표적 거장입니다."
    }
  ],
  "rameau": [
    {
      "question": "장필리프 라모가 남긴 저서 중, '현대 화성학의 출발점'으로 평가받는 이론서의 이름은 무엇인가요?",
      "options": ["화성론", "기능화성학 개론", "대위법 연구", "클라비어 교본"],
      "answer": 0,
      "explanation": "장필리프 라모의 저서 '화성론'은 현대 화성학의 출발점으로 평가받습니다."
    },
    {
      "question": "라모는 화성학의 기초를 어떤 방식으로 정리한 최초의 인물인가요?",
      "options": ["종교적이고 신비주의적인 방식", "과학적인 방식", "즉흥적이고 감정적인 방식", "역사학적인 방식"],
      "answer": 1,
      "explanation": "라모는 화성학의 기초를 과학적으로 정리한 인물입니다."
    },
    {
      "question": "장필리프 라모가 정립하여 고전주의 음악의 이론적 토대가 된 음악 이론은 무엇인가요?",
      "options": ["12음 기법 이론", "기능화성 이론", "총렬주의 이론", "점묘주의 이론"],
      "answer": 1,
      "explanation": "라모가 정립한 기능화성 이론은 이후 고전주의 음악의 이론적 토대가 되었습니다."
    },
    {
      "question": "라모가 오페라와 발레 음악에서 뛰어난 업적을 남기며 절정을 이룩한 음악 양식은 무엇인가요?",
      "options": ["이탈리아 바로크 음악", "프랑스 바로크 음악", "독일 고전주의 음악", "러시아 낭만주의 음악"],
      "answer": 1,
      "explanation": "라모는 프랑스 바로크 음악의 절정을 이룩한 인물입니다."
    },
    {
      "question": "장필리프 라모는 음악사적으로 어느 시대들에 걸쳐 활동했나요?",
      "options": ["르네상스 말기부터 바로크 초기", "바로크 말기부터 고전주의 초기", "고전주의 말기부터 낭만주의 초기", "후기 낭만주의부터 현대 음악"],
      "answer": 1,
      "explanation": "라모는 바로크 말기부터 고전주의 초기에 걸쳐 활동했습니다."
    }
  ],
  "telemann": [
    {
      "question": "게오르크 필리프 텔레만이 평생 남긴 작품의 수는 대략 몇 곡인가요?",
      "options": ["500여 곡", "600여 곡", "1000여 곡", "3000여 곡"],
      "answer": 3,
      "explanation": "텔레만은 3000곡이 넘는 작품을 남긴 다작가였습니다."
    },
    {
      "question": "텔레만의 생전 사회적 명성에 대한 설명으로 올바른 것은 무엇인가요?",
      "options": ["생전에는 무명이었으나 사후에 재평가받았다", "생전에는 바흐보다 더 높은 명성을 누렸다", "오직 이탈리아에서만 인기가 있었다", "음악 이론가로만 명성이 높았다"],
      "answer": 1,
      "explanation": "텔레만은 생전에 바흐보다 더 높은 명성을 누렸던 당대 유럽 최고의 유명인 중 한 명이었습니다."
    },
    {
      "question": "텔레만이 자신의 음악 속에서 절묘하게 결합해낸 두 국가의 음악 양식은 무엇인가요?",
      "options": ["독일과 프랑스 양식", "프랑스와 이탈리아 양식", "이탈리아와 영국 양식", "러시아와 스페인 양식"],
      "answer": 0,
      "explanation": "텔레만은 독일과 프랑스 양식을 절묘하게 결합했습니다."
    },
    {
      "question": "다음 중 텔레만이 곡을 남기지 않은 장르는 무엇인가요?",
      "options": ["교회 음악 및 오페라", "협주곡 및 실내악", "우연성 음악 및 전자 음악", "위에 언급된 모든 장르를 작곡함"],
      "answer": 2,
      "explanation": "텔레만은 교회 음악, 협주곡, 실내악, 오페라 등 거의 모든 장르를 작곡했으나 우연성 및 전자 음악은 현대 장르이므로 해당하지 않습니다."
    },
    {
      "question": "게오르크 필리프 텔레만의 출신 국가는 어디인가요?",
      "options": ["프랑스", "이탈리아", "독일", "오스트리아"],
      "answer": 2,
      "explanation": "텔레만은 독일의 작곡가입니다."
    }
  ],
  "handel": [
    {
      "question": "게오르크 프리드리히 헨델이 남긴 서양 음악 역사상 가장 유명한 오라토리오 작품은 무엇인가요?",
      "options": ["예프타", "발타자르", "메시아", "전쟁 레퀴엠"],
      "answer": 2,
      "explanation": "헨델의 대표작 '메시아'는 서양 음악 역사상 가장 유명한 오라토리오입니다."
    },
    {
      "question": "오라토리오 '메시아' 중 오늘날까지도 가장 널리 알려지고 연주되는 유명한 합창곡은 무엇인가요?",
      "options": ["디도의 비가", "할렐루야 합창", "천인 합창", "불새 합창"],
      "answer": 1,
      "explanation": "메시아 중 '할렐루야 합창'은 오늘날까지도 널리 연주됩니다."
    },
    {
      "question": "다음 중 헨델이 작곡한 유명한 관현악 작품이 아닌 것은 무엇인가요?",
      "options": ["왕궁의 불꽃놀이 음악", "수상 음악", "브란덴부르크 협주곡", "위에 언급된 곡 모두 헨델의 작품이다"],
      "answer": 2,
      "explanation": "왕궁의 불꽃놀이 음악과 수상 음악은 헨델의 대표작이지만, 브란덴부르크 협주곡은 바흐의 작품입니다."
    },
    {
      "question": "헨델의 음악적 스타일을 가장 잘 대변하는 두 가지 특징은 무엇인가요?",
      "options": ["극도로 짧고 응축된 점묘주의", "웅장한 합창과 극적인 표현", "우연성과 동양 철학의 결합", "날카롭고 기계적인 리듬"],
      "answer": 1,
      "explanation": "헨델은 웅장한 합창과 극적인 표현이 특징인 작곡가입니다."
    },
    {
      "question": "헨델의 생애와 이동 경로를 가장 올바르게 설명한 것은 무엇인가요?",
      "options": ["이탈리아에서 태어나 프랑스에서 활동했다", "독일에서 태어나 영국에서 활동했다", "영국에서 태어나 오스트리아에서 활동했다", "러시아에서 태어나 미국에서 활동했다"],
      "answer": 1,
      "explanation": "헨델은 독일에서 태어나 영국에서 활동한 국제적 작곡가입니다."
    }
  ],
  "bach": [
    {
      "question": "바흐의 작품 중 '모든 조성을 체계적으로 탐구한 건반 음악의 걸작'으로 명시된 것은 무엇인가요?",
      "options": ["평균율 클라비어곡집", "푸가의 기법", "골드베르크 변주곡", "미스터리 소나타"],
      "answer": 0,
      "explanation": "평균율 클라비어곡집은 모든 조성을 체계적으로 탐구한 건반 음악의 걸작입니다."
    },
    {
      "question": "바흐가 대위법 연구를 집대성한 최종적인 성격의 작품 이름은 무엇인가요?",
      "options": ["브란덴부르크 협주곡", "B단조 미사", "푸가의 기법", "마태수난곡"],
      "answer": 2,
      "explanation": "'푸가의 기법'은 바흐의 대위법 연구의 집대성입니다."
    },
    {
      "question": "다음 중 바흐의 종교 음악 최고 걸작으로 본문에서 짝지어 언급한 두 작품은 무엇인가요?",
      "options": ["메시아 & 예프타", "마태수난곡 & B단조 미사", "전쟁 레퀴엠 & 장엄미사", "시간의 종말을 위한 사중주 & 부활"],
      "answer": 1,
      "explanation": "마태수난곡과 B단조 미사는 종교 음악의 최고 걸작으로 평가받습니다."
    },
    {
      "question": "음악사에서 바로크 시대가 막을 내렸다고 간주하는 기준이 되는 역사적 사건은 무엇인가요?",
      "options": ["1741년 비발디의 사망", "1750년 바흐의 사망", "1759년 헨델의 사망", "1827년 베토벤의 사망"],
      "answer": 1,
      "explanation": "1750년 바흐의 사망은 일반적으로 바로크 시대의 종말로 간주됩니다."
    },
    {
      "question": "바흐가 완벽한 수준으로 통합해내어 후대 모든 작곡가들에게 영향을 준 두 가지 음악 이론적 개념은 무엇인가요?",
      "options": ["무조 음악과 12음 기법", "대위법과 화성법", "총렬주의와 점묘주의", "인상주의와 원시주의"],
      "answer": 1,
      "explanation": "바흐는 대위법과 화성법을 완벽한 수준으로 통합했습니다."
    }
  ],

  // ==========================================
  // 2. 고전주의 작곡가 (Classical_composer.txt)
  // ==========================================
  "scarlatti": [
    {
      "question": "도메니코 스카를라티가 남긴 건반 소나타는 총 몇 곡인가요?",
      "options": ["100여 곡", "555곡", "600여 곡", "3000여 곡"],
      "answer": 1,
      "explanation": "도메니코 스카를라티는 555곡의 건반 소나타를 남겼습니다."
    },
    {
      "question": "스카를라티가 건반악기에 전격 도입하여 독창적인 화성을 만들어낸 타국 음악 요소는 무엇인가요?",
      "options": ["프랑스 궁정 발레 리듬", "스페인 민속 음악과 기타 연주 기법", "독일 프로테스탄트 찬송가", "러시아의 강렬한 민속 음계"],
      "answer": 1,
      "explanation": "스카를라티는 스페인 민속 음악과 기타 연주 기법을 건반악기에 도입했습니다."
    },
    {
      "question": "스카를라티의 짧은 소나타들이 음악사적으로 기여하여 어떤 장르의 선구로 평가받나요?",
      "options": ["고전주의 피아노 소나타", "낭만주의 표제 교향곡", "현대 총렬주의 음악", "바로크 트리오 소나타"],
      "answer": 0,
      "explanation": "그의 한 악장 형식의 짧은 소나타들은 고전주의 피아노 소나타의 선구로 평가됩니다."
    },
    {
      "question": "다음 중 도메니코 스카를라티의 건반악기 연주 및 화성적 특징이 아닌 것은 무엇인가요?",
      "options": ["빠른 손 교차", "화려한 기교", "독창적인 화성 사용", "극도로 길고 정교한 4악장 구조"],
      "answer": 3,
      "explanation": "스카를라티의 소나타는 한 악장 형식의 짧은 소나타가 특징입니다."
    },
    {
      "question": "도메니코 스카를라티는 바흐·헨델과 어떤 공통점을 가지고 있나요?",
      "options": ["같은 이탈리아 출신이다", "같은 해(1685년)에 태어났다", "모두 영국 왕실의 지원을 받았다", "음악사에서 같은 방향으로 발전했다"],
      "answer": 1,
      "explanation": "스카를라티는 바흐, 헨델과 같은 해(1685년)에 태어났지만 전혀 다른 방향으로 발전했습니다."
    }
  ],
  "pergolesi": [
    {
      "question": "조반니 바티스타 페르골레시가 세상을 떠난 나이는 몇 세인가요?",
      "options": ["26세", "31세", "36세", "53세"],
      "answer": 0,
      "explanation": "페르골레시는 26세라는 아주 젊은 나이에 요절했습니다."
    },
    {
      "question": "페르골레시가 남긴 희가극이자, 오페라 부파의 대표작으로 꼽히는 작품은 무엇인가요?",
      "options": ["피가로의 결혼", "시녀 마님", "돈 조반니", "마술피리"],
      "answer": 1,
      "explanation": "희가극 '시녀 마님'은 페르골레시의 작품이자 오페라 부파의 대표작입니다."
    },
    {
      "question": "페르골레시의 선율이 지닌 특징으로, 바로크에서 고전주의로 넘어가는 전환점을 보여주는 요소는 무엇인가요?",
      "options": ["복잡하고 장식적인 선율", "단순하고 자연스러운 선율", "무조적이고 기계적인 선율", "철저한 대위법적 선율"],
      "answer": 1,
      "explanation": "그의 단순하고 자연스러운 선율은 바로크의 복잡한 양식에서 고전주의의 명료한 양식으로 넘어가는 전환점을 보여줍니다."
    },
    {
      "question": "조반니 바티스타 페르골레시는 주로 어떤 장르의 발전에 큰 영향을 미쳤나요?",
      "options": ["고전주의 오페라", "오르간 코랄 프렐루드", "현악 사중주", "표제 관현악곡"],
      "answer": 0,
      "explanation": "페르골레시는 고전주의 오페라 발전에 큰 영향을 미쳤습니다."
    },
    {
      "question": "페르골레시의 선율 스타일이 이끌어낸 고전주의 양식의 핵심 성격은 무엇인가요?",
      "options": ["신비주의", "명료함", "감정과다", "원시주의"],
      "answer": 1,
      "explanation": "페르골레시는 바로크의 복잡함에서 고전주의의 '명료한 양식'으로 넘어가는 길목을 지키고 있습니다."
    }
  ],
  "cpe_bach": [
    {
      "question": "요한 제바스티안 바흐의 둘째 아들이자, '감정과다 양식'의 대표 작곡가는 누구인가요?",
      "options": ["칼 필리프 에마누엘 바흐", "요한 크리스티안 바흐", "윌리엄 프리드만 바흐", "요한 슈타미츠"],
      "answer": 0,
      "explanation": "칼 필리프 에마누엘 바흐(C.P.E. 바흐)는 바흐의 둘째 아들이자 감정과다 양식의 대가입니다."
    },
    {
      "question": "C.P.E. 바흐가 음악 속에서 사용한 기법으로, 낭만주의의 선구적 모습을 보여준 특징은 무엇인가요?",
      "options": ["엄격한 대위법과 화성법의 결합", "예측할 수 없는 전조와 강한 감정 표현", "12음의 균등한 배열", "민속 음악의 정교한 채보"],
      "answer": 1,
      "explanation": "C.P.E. 바흐는 예측할 수 없는 전조와 강한 감정 표현을 사용해 낭만주의의 선구적 모습을 보여주었습니다."
    },
    {
      "question": "다음 중 C.P.E. 바흐에게 큰 영향을 받았다고 본문에 직접 명시되지 않은 작곡가는 누구인가요?",
      "options": ["요제프 하이든", "볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "클로드 드뷔시"],
      "answer": 3,
      "explanation": "하이든, 모차르트, 베토벤 모두 C.P.E. 바흐에게 큰 영향을 받았습니다."
    },
    {
      "question": "C.P.E. 바흐가 대표하는 음악 사조 또는 양식의 명칭은 무엇인가요?",
      "options": ["갈랑 양식", "감정과다 양식", "인상주의 양식", "복합창 양식"],
      "answer": 1,
      "explanation": "C.P.E. 바흐는 감정과다 양식(Empfindsamer Stil)의 대표 작곡가입니다."
    },
    {
      "question": "C.P.E. 바흐의 음악적 성향은 훗날 어떤 음악 사조의 선구적인 모습으로 평가받나요?",
      "options": ["고전주의", "낭만주의", "원시주의", "신고전주의"],
      "answer": 1,
      "explanation": "그의 강한 감정 표현 등은 낭만주의의 선구적 모습을 보여주었다고 평가받습니다."
    }
  ],
  "jc_bach": [
    {
      "question": "요한 제바스티안 바흐의 막내아들이자, 주로 영국에서 활동하여 '런던의 바흐'로 불린 인물은 누구인가요?",
      "options": ["칼 필리프 에마누엘 바흐", "요한 크리스티안 바흐", "조반니 바티스타 페르골레시", "무치오 클레멘티"],
      "answer": 1,
      "explanation": "요한 크리스티안 바흐(J.C. 바흐)는 바흐의 막내아들이자 '런던의 바흐'로 불렸습니다."
    },
    {
      "question": "요한 크리스티안 바흐가 대표했던 음악 양식의 명칭은 무엇인가요?",
      "options": ["감정과다 양식", "갈랑 양식", "복합창 양식", "점묘주의 양식"],
      "answer": 1,
      "explanation": "요한 크리스티안 바흐는 갈랑 양식의 대표 작곡가였습니다."
    },
    {
      "question": "J.C. 바흐의 우아하고 단순한 선율은 고전주의의 어떤 장르 발전에 기여했나요?",
      "options": ["오페라와 오라토리오", "협주곡과 교향곡", "피아노 소나티네와 토카타", "현악 사중주와 오중주"],
      "answer": 1,
      "explanation": "그는 우아하고 단순한 선율을 통해 고전주의 협주곡과 교향곡 발전에 영향을 주었습니다."
    },
    {
      "question": "J.C. 바흐를 어릴 때 직접 만나 음악적 가르침과 영향을 받았던 천재 작곡가는 누구인가요?",
      "options": ["볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "요제프 하이든", "펠릭스 멘델스존"],
      "answer": 0,
      "explanation": "어린 모차르트가 J.C. 바흐를 직접 만나 배우기도 했습니다."
    },
    {
      "question": "J.C. 바흐 선율이 지닌 가장 큰 외형적 특징 두 가지는 무엇인가요?",
      "options": ["기계적이고 타격감 넘치는 음향", "우아하고 단순함", "예측 불가능하고 격정적임", "종교적이고 장엄함"],
      "answer": 1,
      "explanation": "J.C. 바흐는 우아하고 단순한 선율이 특징인 갈랑 양식의 대가였습니다."
    }
  ],
  "stamitz": [
    {
      "question": "만하임 악파의 중심 인물이자, 현대 교향악단의 기본 구조를 정립한 작곡가는 누구인가요?",
      "options": ["요한 슈타미츠", "카를 디터스도르프", "레오폴트 모차르트", "요제프 하이든"],
      "answer": 0,
      "explanation": "요한 슈타미츠는 만하임 악파의 중심 인물로 현대 교향악단의 기본 구조를 세웠습니다."
    },
    {
      "question": "요한 슈타미츠가 개발한 대표적인 새로운 오케스트라 기법 두 가지는 무엇인가요?",
      "options": ["현악 트레몰로 & 피치카토", "스코르다투라 & 리토르넬로", "만하임 크레셴도 & 만하임 로켓", "라이트모티프 & 트리스탄 화음"],
      "answer": 2,
      "explanation": "슈타미츠는 만하임 크레셴도, 만하임 로켓 같은 새로운 오케스트라 기법을 개발했습니다."
    },
    {
      "question": "요한 슈타미츠는 어떤 장르를 독립된 예술 장르로 발전시키는 데 결정적인 역할을 했나요?",
      "options": ["오페라", "교향곡", "피아노 소나타", "현악 사중주"],
      "answer": 1,
      "explanation": "슈타미츠는 교향곡을 독립된 예술 장르로 발전시키는 데 결정적 역할을 했습니다."
    },
    {
      "question": "요한 슈타미츠의 출신 배경이 되는 두 지역(또는 국가)은 어디인가요?",
      "options": ["이탈리아와 프랑스", "보헤미아와 독일", "오스트리아와 영국", "러시아와 폴란드"],
      "answer": 1,
      "explanation": "요한 슈타미츠는 보헤미아·독일 출신의 작곡가입니다."
    },
    {
      "question": "요한 슈타미츠가 정립하는 데 기여한 '현대 이것'의 기본 구조는 무엇인가요?",
      "options": ["현대 오페라단", "현대 교향악단(오케스트라)", "현대 피아노 교육 체계", "현대 음악 평론지"],
      "answer": 1,
      "explanation": "요한 슈타미츠는 현대 교향악단의 기본 구조를 정립한 공로가 큽니다."
    }
  ],
  "dittersdorf": [
    {
      "question": "카를 디터스 폰 디터스도르프는 어느 음악 시대의 발전에 기여했나요?",
      "options": ["초기 바로크", "초기 고전주의", "전성기 낭만주의", "20세기 전위음악"],
      "answer": 1,
      "explanation": "카를 디터스 폰 디터스도르프는 고전주의 초기 교향곡 발전에 기여한 작곡가입니다."
    },
    {
      "question": "디터스도르프가 남긴 교향곡의 총 개수는 대략 몇 곡 이상인가요?",
      "options": ["9곡", "15곡", "100곡 넘게", "555곡"],
      "answer": 2,
      "explanation": "디터스도르프는 100곡이 넘는 교향곡을 남겼습니다."
    },
    {
      "question": "당대(고전주의 초기)에 디터스도르프는 누구와 함께 대중에게 널리 알려졌었나요?",
      "options": ["요한 제바스티안 바흐", "요제프 하이든", "루트비히 판 베토벤", "클로드 드뷔시"],
      "answer": 1,
      "explanation": "디터스도르프는 당시 하이든과 함께 대중에게 널리 알려졌던 인물입니다."
    },
    {
      "question": "카를 디터스 폰 디터스도르프의 국적은 어디인가요?",
      "options": ["독일", "이탈리아", "오스트리아", "프랑스"],
      "answer": 2,
      "explanation": "디터스도르프는 오스트리아의 작곡가입니다."
    },
    {
      "question": "디터스도르프가 주로 남긴 핵심 음악적 장르는 무엇인가요?",
      "options": ["교향곡", "오페라 부파", "클라브생 독주곡", "예술 가곡 연작"],
      "answer": 0,
      "explanation": "디터스도르프는 100곡이 넘는 '교향곡'을 남긴 것으로 명시되어 있습니다."
    }
  ],
  "l_mozart": [
    {
      "question": "레오폴트 모차르트는 역사상 누구의 아버지로 가장 유명한가요?",
      "options": ["볼프강 아마데우스 모차르트", "카를 필리프 에마누엘 바흐", "루트비히 판 베토벤", "펠릭스 멘델스존"],
      "answer": 0,
      "explanation": "레오폴트 모차르트는 볼프강 아마데우스 모차르트의 아버지입니다."
    },
    {
      "question": "레오폴트 모차르트가 저술하여 고전주의 초기 음악 교육에 큰 영향을 준 교본의 악기는 무엇인가요?",
      "options": ["피아노 교본", "바이올린 교본", "플루트 교본", "첼로 교본"],
      "answer": 1,
      "explanation": "레오폴트 모차르트는 바이올린 교본 저술로 유명합니다."
    },
    {
      "question": "레오폴트 모차르트가 음악사적으로 가장 크게 기여한 분야는 무엇인가요?",
      "options": ["무조 음악 이론 정립", "고전주의 초기 음악 교육", "오페라 악극 장르 창시", "표제 관현악법 개척"],
      "answer": 1,
      "explanation": "그는 바이올린 교본 저술 등을 통해 고전주의 초기 음악 교육에 큰 영향을 주었습니다."
    },
    {
      "question": "레오폴트 모차르트의 국적으로 명시된 두 국가는 어디인가요?",
      "options": ["프랑스·이탈리아", "독일·오스트리아", "보헤미아·독일", "영국·러시아"],
      "answer": 1,
      "explanation": "레오폴트 모차르트는 독일·오스트리아 국적의 음악가입니다."
    },
    {
      "question": "레오폴트 모차르트가 활발히 활동하고 저술을 남긴 음악사적 시기는 언제인가요?",
      "options": ["중기 바로크", "고전주의 초기", "전성기 고전주의", "후기 낭만주의"],
      "answer": 1,
      "explanation": "레오폴트 모차르트는 '고전주의 초기 음악 교육에 큰 영향을 주었다'고 서술되어 있습니다."
    }
  ],
  "haydn": [
    {
      "question": "요제프 하이든이 음악사에서 얻은 대표적인 두 가지 별명(아버지)은 무엇인가요?",
      "options": ["피아노의 아버지 & 오페라의 아버지", "교향곡의 아버지 & 현악 사중주의 아버지", "화성학의 아버지 & 대위법의 아버지", "현대 오케스트레이션의 아버지 & 가곡의 아버지"],
      "answer": 1,
      "explanation": "하이든은 '교향곡의 아버지', '현악 사중주의 아버지'로 불립니다."
    },
    {
      "question": "하이든이 오랜 기간 궁정악장으로 고립되어 활동하며 독자적 음악 세계를 구축했던 가문은 어디인가요?",
      "options": ["루이 14세 가문", "에스테르하지 가문", "피렌체 카메라타", "메디치 가문"],
      "answer": 1,
      "explanation": "하이든은 오랜 기간 에스테르하지 가문의 궁정악장으로 활동했습니다."
    },
    {
      "question": "다음 중 요제프 하이든의 대표 교향곡 제목이 아닌 것은 무엇인가요?",
      "options": ["제94번 놀람", "제101번 시계", "제104번 런던", "제5번 운명"],
      "answer": 3,
      "explanation": "놀람, 시계, 런던은 하이든의 교향곡이지만, '운명' 교향곡은 베토벤의 작품입니다."
    },
    {
      "question": "하이든은 낭만주의의 문을 연 어떤 위대한 작곡가의 스승이었나요?",
      "options": ["볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "프란츠 슈베르트", "요하네스 브람스"],
      "answer": 1,
      "explanation": "요제프 하이든은 베토벤의 스승이기도 했습니다."
    },
    {
      "question": "하이든이 고전주의 형식을 완성하기 위해 작곡한 교향곡의 수는 대략 몇 곡 이상인가요?",
      "options": ["9곡", "41곡", "100곡 넘게", "600여 곡"],
      "answer": 2,
      "explanation": "하이든은 100곡이 넘는 교향곡과 수많은 현악 사중주를 남겼습니다."
    }
  ],
  "mozart": [
    {
      "question": "볼프강 아마데우스 모차르트가 35세라는 짧은 생애 동안 남긴 총 작품의 수는 몇 곡 이상인가요?",
      "options": ["100여 곡", "555곡", "600곡 넘게", "3000여 곡"],
      "answer": 2,
      "explanation": "모차르트는 35세의 짧은 생애 동안 600곡이 넘는 작품을 남겼습니다."
    },
    {
      "question": "다음 중 모차르트의 대표 교향곡 번호와 별칭이 올바르게 묶인 것은 무엇인가요?",
      "options": ["교향곡 3번 영웅", "교향곡 5번 운명", "교향곡 41번 주피터", "교향곡 6번 전원"],
      "answer": 2,
      "explanation": "모차르트의 대표 교향곡으로는 40번과 41번 '주피터'가 있습니다. 영웅, 운명, 전원은 베토벤의 곡입니다."
    },
    {
      "question": "다음 중 모차르트가 남긴 유명한 오페라 작품이 아닌 것은 무엇인가요?",
      "options": ["피가로의 결혼", "돈 조반니", "마술피리", "카르멘"],
      "answer": 3,
      "explanation": "피가로의 결혼, 돈 조반니, 마술피리는 모차르트의 대표작이며, 카르멘은 비제의 오페라입니다."
    },
    {
      "question": "모차르트가 미처 완성하지 못하고 세상을 떠난, 대표작 목록에 포함된 종교성악곡은 무엇인가요?",
      "options": ["B단조 미사", "독일 레퀴엠", "레퀴엠", "장엄미사"],
      "answer": 2,
      "explanation": "모차르트의 대표작 중 하나로 미완성 유작인 '레퀴엠'이 언급되어 있습니다."
    },
    {
      "question": "모차르트 음악이 고전주의 이상을 완전하게 구현했다고 평가받는 핵심 예술적 요소 두 가지는 무엇인가요?",
      "options": ["완벽한 균형과 아름다운 선율", "강렬한 리듬과 기계적 언어", "풍자와 저항 정신", "신비주의와 극단적 화성"],
      "answer": 0,
      "explanation": "모차르트는 완벽한 균형과 아름다운 선율로 고전주의의 이상을 가장 완전하게 구현했습니다."
    }
  ],
  "clementi": [
    {
      "question": "음악사에서 '피아노의 아버지'로 불리는 고전주의 작곡가는 누구인가요?",
      "options": ["무치오 클레멘티", "루이지 보케리니", "루트비히 판 베토벤", "프레데리크 쇼پن"],
      "answer": 0,
      "explanation": "무치오 클레멘티는 '피아노의 아버지'로 불리는 작곡가입니다."
    },
    {
      "question": "클레멘티가 작곡한 작품들로, 오늘날까지 피아노 교육용 교재로 널리 사용되는 장르는 무엇인가요?",
      "options": ["소나티네", "녹턴", "토카타", "미크로코스모스"],
      "answer": 0,
      "explanation": "클레멘티의 소나티네 작품들은 오늘날까지 피아노 교육용 교재로 널리 사용됩니다."
    },
    {
      "question": "무치오 클레멘티는 어떤 악기의 연주 기법 발전에 가장 큰 영향을 미쳤나요?",
      "options": ["바이올린", "첼로", "피아노", "오르간"],
      "answer": 2,
      "explanation": "클레멘티는 피아노 연주 기법 발전에 큰 영향을 미쳤습니다."
    },
    {
      "question": "무치오 클레멘티의 출신 국가는 어디인가요?",
      "options": ["독일", "이탈리아", "프랑스", "오스트리아"],
      "answer": 1,
      "explanation": "무치오 클레멘티는 이탈리아 출신의 작곡가입니다."
    },
    {
      "question": "클레멘티가 음악사에서 차지하는 핵심적인 위치는 무엇인가요?",
      "options": ["오케스트라 크레셴도 기법의 최초 개발", "고전주의 피아노 음악 발전의 핵심 인물", "예술 가곡 장르의 완성", "인상주의 화성의 기틀 마련"],
      "answer": 1,
      "explanation": "클레멘티는 고전주의 피아노 음악 발전의 핵심 인물입니다."
    }
  ],
  "boccherini": [
    {
      "question": "루이지 보케리니는 작곡가인 동시에 어떤 악기의 뛰어난 연주자(첼리스트)였나요?",
      "options": ["바이올린", "비올라", "첼로", "더블베이스"],
      "answer": 2,
      "explanation": "루이지 보케리니는 첼리스트이자 작곡가였습니다."
    },
    {
      "question": "루이지 보케리니가 음악사적으로 발전시키는 데 가장 중요한 역할을 한 실내악 장르는 무엇인가요?",
      "options": ["트리오 소나타", "현악 사중주", "현악 오중주", "피아노 삼중주"],
      "answer": 2,
      "explanation": "보케리니는 현악 오중주 발전에 중요한 역할을 했습니다."
    },
    {
      "question": "보케리니의 실내악 작품들을 설명하는 대표적인 두 가지 형용사는 무엇인가요?",
      "options": ["우아하고 세련됨", "날카롭고 파격적임", "웅장하고 괴기스러움", "단순하고 투박함"],
      "answer": 0,
      "explanation": "보케리니는 우아하고 세련된 실내악 작품으로 유명합니다."
    },
    {
      "question": "루이지 보케리니의 국적은 어디인가요?",
      "options": ["이탈리아", "프랑스", "독일", "보헤미아"],
      "answer": 0,
      "explanation": "루이지 보케리니는 이탈리아의 음악가입니다."
    },
    {
      "question": "보케리니는 어느 음악 사조의 작곡가로 분류되어 있나요?",
      "options": ["바로크 시대", "고전주의 시대", "낭만주의 시대", "현대 음악 시대"],
      "answer": 1,
      "explanation": "루이지 보케리니는 고전주의 작곡가 파일(Classical_composer.txt)에 포함되어 있습니다."
    }
  ],
  "beethoven": [
    {
      "question": "다음 중 루트비히 판 베토벤의 대표 교향곡 별칭과 번호가 잘못 연결된 것은 무엇인가요?",
      "options": ["교향곡 제3번 영웅", "교향곡 제5번 운명", "교향곡 제6번 전원", "교향곡 제9번 비창"],
      "answer": 3,
      "explanation": "교향곡 9번의 별칭은 '합창'입니다. 비창은 베토벤의 피아노 소나타 제목(혹은 차이콥스키 교향곡 6번)입니다."
    },
    {
      "question": "베토벤이 음악사에서 차지하는 가장 거대한 역사적 위치는 무엇인가요?",
      "options": ["바로크 복합창 양식의 완성", "고전주의와 낭만주의를 연결한 최대의 전환점", "무조 음악의 완벽한 기틀 정립", "영국 오페라 부흥의 시작"],
      "answer": 1,
      "explanation": "베토벤은 고전주의와 낭만주의를 연결한 음악사 최대의 전환점입니다."
    },
    {
      "question": "다음 중 베토벤의 3대 피아노 소나타로 본문에 명시된 작품들의 조합은 무엇인가요?",
      "options": ["놀람 - 시계 - 런던", "비창 - 월광 - 열정", "어린이 정경 - 카니발 - 소나티네", "목신의 오후 - 달빛 - 거울"],
      "answer": 1,
      "explanation": "베토벤의 피아노 소나타로는 비창, 월광, 열정이 대표작으로 언급되어 있습니다."
    },
    {
      "question": "베토벤이 신체적 치명상인 '이것'을 겪으면서도 음악을 인간 정신과 의지의 표현 수단으로 승화시켰나요?",
      "options": ["시력 상실", "청력 상실", "하반신 마비", "기억 상실"],
      "answer": 1,
      "explanation": "베토벤은 청력을 잃어가는 상황 속에서도 창작을 멈추지 않았습니다."
    },
    {
      "question": "음악사에서 고전주의 시대가 사실상 막을 내리게 된 계기가 되는 사건은 무엇인가요?",
      "options": ["1791년 모차르트의 사망", "1809년 하이든의 사망", "1827년 베토벤의 사망", "1856년 슈만의 사망"],
      "answer": 2,
      "explanation": "1827년 베토벤의 사망과 함께 고전주의 시대는 사실상 막을 내립니다."
    }
  ],

  // ==========================================
  // 3. 낭만주의 작곡가 (Romantic_composer.txt)
  // ==========================================
  "schubert": [
    {
      "question": "600곡이 넘는 가곡을 작곡하여 '예술 가곡' 장르를 완성하고 낭만주의 음악의 실질적 출발점이 된 작곡가는 누구인가요?",
      "options": ["프란츠 슈베르트", "로베르트 슈만", "펠릭스 멘델스존", "요하네스 브람스"],
      "answer": 0,
      "explanation": "프란츠 슈베르트는 예술 가곡 장르를 완성하며 낭만주의 음악의 실질적 출발점이 되었습니다."
    },
    {
      "question": "다음 중 슈베르트의 대표 예술 가곡(또는 가곡집)이 아닌 것은 무엇인가요?",
      "options": ["마왕", "보리수", "겨울 나그네", "시인의 사랑"],
      "answer": 3,
      "explanation": "마왕, 보리수, 겨울 나그네, 아름다운 물방앗간 아가씨는 슈베르트의 곡이며, '시인의 사랑'은 슈만의 연가곡집입니다."
    },
    {
      "question": "슈베르트가 남긴 대표 교향곡 두 편의 별칭은 무엇인가요?",
      "options": ["운명 & 전원", "영웅 & 합창", "미완성 & 그레이트", "놀람 & 시계"],
      "answer": 2,
      "explanation": "슈베르트는 교향곡 제8번 '미완성', 제9번 '그레이트'로 유명합니다."
    },
    {
      "question": "슈베르트의 음악 스타일이 지닌 가장 큰 구조적 특징은 무엇인가요?",
      "options": ["고전주의 형식을 파괴하고 완전히 무조 음악으로 전환함", "고전주의 형식을 유지하면서도 낭만주의 특유의 서정성과 감성을 담아냄", "오케스트라 규모를 극한으로 줄여 점묘주의를 추구함", "스페인 민속 리듬만을 집요하게 사용함"],
      "answer": 1,
      "explanation": "슈베르트는 고전주의 형식을 유지하면서도 낭만주의 특유의 서정성과 감성을 담아냈습니다."
    },
    {
      "question": "프란츠 슈베르트가 요절했을 당시의 나이는 몇 세였나요?",
      "options": ["26세", "31세", "36세", "45세"],
      "answer": 1,
      "explanation": "슈베르트는 31세의 젊은 나이에 요절했습니다."
    }
  ],
  "weber": [
    {
      "question": "독일 민속 전설과 초자연적 요소를 결합하여 '독일 낭만주의 오페라의 창시자'로 불리는 작곡가는 누구인가요?",
      "options": ["카를 마리아 폰 베버", "리하르트 바그너", "로베르트 슈만", "리하르트 슈트라우스"],
      "answer": 0,
      "explanation": "카를 마리아 폰 베버는 독일 낭만주의 오페라의 창시자입니다."
    },
    {
      "question": "독일 낭만주의 최초의 본격 오페라로 평가받는 베버의 대표작 제목은 무엇인가요?",
      "options": ["다프네", "마탄의 사수", "나부코", "살로메"],
      "answer": 1,
      "explanation": "베버의 대표작 '마탄의 사수'는 최초의 본격 낭만주의 오페라입니다."
    },
    {
      "question": "베버의 오페라 '마탄의 사수'가 결합한 핵심적인 두 가지 서사적 요소는 무엇인가요?",
      "options": ["그리스 신화와 역사적 사실", "독일 민속 전설과 초자연적 요소", "스탈린 체제의 압박과 풍자", "성경 이야기와 화려한 발레"],
      "answer": 1,
      "explanation": "'마탄의 사수'는 독일 민속 전설과 초자연적 요소를 결합한 작품입니다."
    },
    {
      "question": "베버의 오페라 혁신은 훗날 어떤 위대한 오페라 작곡가의 직접적인 선조가 되었나요?",
      "options": ["주세페 베르디", "리하르트 바그너", "자코모 푸치니", "조르주 비제"],
      "answer": 1,
      "explanation": "베버의 오페라는 이후 바그너 오페라의 직접적 선조가 됩니다."
    },
    {
      "question": "카를 마리아 폰 베버의 국적은 어디인가요?",
      "options": ["오스트리아", "독일", "프랑스", "이탈리아"],
      "answer": 1,
      "explanation": "베버는 독일의 작곡가입니다."
    }
  ],
  "mendelssohn": [
    {
      "question": "펠릭스 멘델스존의 작품 중 가장 널리 대중적으로 유명한 두 곡은 무엇인가요?",
      "options": ["마왕 & 보리수", "한여름 밤의 꿈 서곡 & 결혼행진곡", "동물의 사육제 & 볼레로", "핀란디아 & 몰다우"],
      "answer": 1,
      "explanation": "멘델스존은 '한여름 밤의 꿈 서곡'과 '결혼행진곡'이 가장 유명합니다."
    },
    {
      "question": "다음 중 멘델스존의 대표 교향곡 두 편의 제목으로 올바르게 묶인 것은 무엇인가요?",
      "options": ["교향곡 제3번 스코틀랜드 & 제4번 이탈리아", "교향곡 제5번 운명 & 제6번 전원", "교향곡 제2번 부활 & 제8번 천인", "교향곡 제4번 비창 & 제9번 신세계"],
      "answer": 0,
      "explanation": "멘델스존의 대표 교향곡은 제3번 '스코틀랜드', 제4번 '이탈리아'입니다."
    },
    {
      "question": "멘델스존이 1829년에 이 작품을 부활 공연하여, 음악사에서 이 위대한 작곡가를 재평가하는 거대한 계기를 마련했습니다. 이 작품은 무엇인가요?",
      "options": ["바흐의 마태수난곡", "헨델의 메시아", "모차르트의 레퀴엠", "베토벤의 장엄미사"],
      "answer": 0,
      "explanation": "멘델스존은 1829년 바흐의 '마태수난곡'을 부활 공연해 바흐 재평가의 계기를 만들었습니다."
    },
    {
      "question": "멘델스존의 음악 스타일이 지닌 가장 큰 성격적 특징은 무엇인가요?",
      "options": ["낭만주의 작곡가이면서도 고전주의적 균형감을 유지함", "전통 조성을 완전히 파괴하고 소음을 도입함", "문학적 요소를 완전히 배제하고 절대 음악만 고집함", "러시아의 거친 감정만을 극단화함"],
      "answer": 0,
      "explanation": "멘델스존은 낭만주의 작곡가이면서도 고전주의적 균형감을 유지한 인물입니다."
    },
    {
      "question": "펠릭스 멘델스존의 출신 국가는 어디인가요?",
      "options": ["오스트리아", "독일", "프랑스", "러시아"],
      "answer": 1,
      "explanation": "펠릭스 멘델스존은 독일의 작곡가입니다."
    }
  ],
  "schumann": [
    {
      "question": "낭만주의 정신을 가장 잘 보여주는 인물로, 평론가로 활동하며 당시 신인이었던 어떤 작곡가들의 천재성을 세상에 알렸나요?",
      "options": ["바흐와 헨델", "하이든과 모차르트", "쇼팽과 브람스", "드뷔시와 라벨"],
      "answer": 2,
      "explanation": "슈만은 음악 평론가로 활동하며 쇼팽과 브람스의 재능을 세상에 알렸습니다."
    },
    {
      "question": "다음 중 로베르트 슈만의 대표작 조합으로 올바른 것은 무엇인가요?",
      "options": ["마왕 - 보리수 - 겨울 나그네", "어린이 정경 - 카니발 - 시인의 사랑", "백조의 호수 - 잠자는 숲속의 미녀", "라 보엠 - 토스카 - 나비 부인"],
      "answer": 1,
      "explanation": "슈만의 대표작으로는 어린이 정경, 카니발, 시인의 사랑 등이 있습니다."
    },
    {
      "question": "로베르트 슈만이 음악을 창작할 때 가장 핵심적으로 추구했던 결합은 무엇인가요?",
      "options": ["과학적 화성과 수학적 리듬의 결합", "문학과 음악의 결합", "동양 철학과 선불교의 결합", "체제 순응과 풍자의 결합"],
      "answer": 1,
      "explanation": "슈만은 문학과 음악의 결합을 추구했습니다."
    },
    {
      "question": "로베르트 슈만은 말년에 어떤 고통을 겪으며 전형적인 낭만주의 예술가상으로 여겨지게 되었나요?",
      "options": ["실명", "청각 장애", "정신 질환", "극심한 경제적 파산"],
      "answer": 2,
      "explanation": "슈만은 정신 질환으로 말년을 보냈으며 낭만주의 예술가상의 전형으로 여겨집니다."
    },
    {
      "question": "로베르트 슈만의 국적은 어디인가요?",
      "options": ["프랑스", "독일", "폴란드", "오스트리아"],
      "answer": 1,
      "explanation": "로베르트 슈만은 독일의 작곡가입니다."
    }
  ],
  "chopin": [
    {
      "question": "거의 모든 작품을 피아노를 위해 작곡하여 '피아노의 시인'으로 불리는 낭만주의 작곡가는 누구인가요?",
      "options": ["프란츠 리스트", "프레데리크 쇼پن", "로베르트 슈만", "카미유 생상스"],
      "answer": 1,
      "explanation": "프레데리크 쇼팽은 '피아노의 음악의 시인'으로 불립니다."
    },
    {
      "question": "다음 중 쇼팽이 정교하게 발전시킨 피아노 음악 장르가 아닌 것은 무엇인가요?",
      "options": ["녹턴과 왈츠", "마주르카와 폴로네즈", "발라드", "교향시"],
      "answer": 3,
      "explanation": "쇼팽은 녹턴, 왈츠, 마주르카, 폴로네즈, 발라드 등을 발전시켰습니다. 교향시는 리스트가 창안한 관현악 장르입니다."
    },
    {
      "question": "쇼팽이 자신의 피아노 음악 속에 깊이 심어둔 조국에 대한 정신은 무엇인가요?",
      "options": ["독일 프로테스탄트 정신", "폴란드 민족주의 정신", "프랑스 인상주의 정신", "소련 체제 순응 정신"],
      "answer": 1,
      "explanation": "쇼팽은 폴란드 민족주의 정신을 음악에 담아낸 대표적 작곡가입니다."
    },
    {
      "question": "쇼팽의 음악이 낭만주의 피아노 음악의 정점을 이룰 수 있었던 세 가지 핵심 요인은 무엇인가요?",
      "options": ["웅장한 금관, 거대한 타악, 복합창의 배치", "섬세한 감성, 아름다운 선율, 혁신적 화성", "수학적 규칙, 과학적 화성, 대위법의 집대성", "우연성, 선불교 사상, 소음의 도입"],
      "answer": 1,
      "explanation": "쇼팽은 섬세한 감성과 아름다운 선율, 혁신적 화성으로 낭만주의 피아노 음악의 정점을 이뤘습니다."
    },
    {
      "question": "프레데리크 쇼팽의 고국은 어디인가요?",
      "options": ["헝가리", "프랑스", "러시아", "폴란드"],
      "answer": 3,
      "explanation": "쇼팽은 폴란드 출신의 작곡가입니다."
    }
  ],
  "liszt": [
    {
      "question": "압도적인 연주 기교로 유럽 전역을 열광시켰던 '역사상 최초의 피아노 슈퍼스타'는 누구인가요?",
      "options": ["프레데리크 쇼پن", "프란츠 리스트", "무치오 클레멘티", "세르게이 라흐마니노프"],
      "answer": 1,
      "explanation": "프란츠 리스트는 역사상 최초의 피아노 슈퍼스타로 불립니다."
    },
    {
      "question": "프란츠 리스트가 오케스트라 분야에서 새로 창안해낸 혁신적인 장르는 무엇인가요?",
      "options": ["표제 교향곡", "교향시", "악극", "오라토리오"],
      "answer": 1,
      "explanation": "리스트는 '교향시'라는 새로운 장르를 창안했습니다."
    },
    {
      "question": "다음 중 프란츠 리스트의 대표작 목록에 포함된 교향곡 혹은 광시곡 작품은 무엇인가요?",
      "options": ["헝가리 광시곡 - 단테 교향곡 - 파우스트 교향곡", "신세계로부터 - 나의 조국 - 몰다우", "부활 교향곡 - 천인 교향곡", "비창 교향곡 - 놀람 교향곡"],
      "answer": 0,
      "explanation": "리스트의 대표작으로 헝가리 광시곡, 단테 교향곡, 파우스트 교향곡 등이 명시되어 있습니다."
    },
    {
      "question": "프란츠 리스트가 말년(후기)에 남긴 작품들의 성격은 어떠했나요?",
      "options": ["더욱 화려하고 압도적인 피아노 기교 곡만 고집함", "종교 음악과 실험적 작품을 남기며 현대 음악의 선구적 역할 수행", "체제에 순응하는 풍자 음악 작곡", "체코의 정체성을 담은 민족주의 교향시 작곡"],
      "answer": 1,
      "explanation": "리스트는 후기에 종교 음악과 실험적 작품을 남기며 현대 음악의 선구적 역할을 했습니다."
    },
    {
      "question": "프란츠 리스트의 출신 국가는 어디인가요?",
      "options": ["폴란드", "러시아", "헝가리", "독일"],
      "answer": 2,
      "explanation": "프란츠 리스트는 헝가리 출신의 작곡가입니다."
    }
  ],
  "berlioz": [
    {
      "question": "엑토르 베를리오즈의 대표작으로, 낭만주의 관현악 음악의 대명사로 불리는 이 교향곡의 이름은 무엇인가요?",
      "options": ["환상 교향곡", "단테 교향곡", "파우스트 교향곡", "천인 교향곡"],
      "answer": 0,
      "explanation": "베를리오즈의 '환상 교향곡'은 낭만주의 관현악 음악의 대표작입니다."
    },
    {
      "question": "베를리오즈가 음악사에서 이 장르의 '개척자'로 불리게 만든 음악적 사조는 무엇인가요?",
      "options": ["절대 음악", "표제 음악", "무조 음악", "우연성 음악"],
      "answer": 1,
      "explanation": "엑토르 베를리오즈는 표제 음악의 개척자입니다."
    },
    {
      "question": "베를리오즈가 관현악 발전에 기여한 업적 때문에 얻은 영광스러운 별명은 무엇인가요?",
      "options": ["피아노의 아버지", "현대 오케스트레이션(관현악법)의 아버지", "교향곡의 아버지", "독일 오페라의 아버지"],
      "answer": 1,
      "explanation": "베를리오즈는 현대 오케스트레이션의 아버지로 불립니다."
    },
    {
      "question": "베를리오즈가 추구하고 발전시킨 오케스트라 편성 및 기법의 특징은 무엇인가요?",
      "options": ["극도로 축소된 실내악 편성", "대규모 오케스트라 편성과 독창적인 관현악법", "현악기를 완전히 배제한 타악 편성", "전통적인 하이든식 고전 편성의 엄격한 고수"],
      "answer": 1,
      "explanation": "그는 대규모 오케스트라 편성과 독창적인 관현악법을 발전시켰습니다."
    },
    {
      "question": "엑토르 베를리오즈의 국적은 어디인가요?",
      "options": ["독일", "프랑스", "이탈리아", "오스트리아"],
      "answer": 1,
      "explanation": "엑토르 베를리오즈는 프랑스 출신의 작곡가입니다."
    }
  ],
  "wagner": [
    {
      "question": "리하르트 바그너가 자신의 오페라 작품을 전통 오페라와 차별화하여 부르던 명칭은 무엇인가요?",
      "options": ["오페라 부파", "오라토리오", "악극 (Musikdrama)", "교향시"],
      "answer": 2,
      "explanation": "바그너는 자신의 작품을 오페라가 아닌 악극(Musikdrama)이라 불렀습니다."
    },
    {
      "question": "바그너가 추구했던 개념으로, 음악과 문학, 무대 예술을 하나로 통합한 예술을 뜻하는 용어는 무엇인가요?",
      "options": ["갈랑 양식", "감정과다 양식", "총체 예술 작품 (Gesamtkunstwerk)", "복합창 양식"],
      "answer": 2,
      "explanation": "바그너는 음악, 문학, 무대 예술을 통합한 총체 예술 작품을 추구했습니다."
    },
    {
      "question": "바그너가 작곡한 대작으로, 4부작으로 구성된 대표 악극의 이름은 무엇인가요?",
      "options": ["니벨룽의 반지", "트리스탄과 이졸데", "파르지팔", "피가로의 결혼"],
      "answer": 0,
      "explanation": "바그너의 대표작으로는 '니벨룽의 반지 4부작'이 있습니다."
    },
    {
      "question": "바그너가 사용한 기법으로, 특정 인물이나 상황, 사물을 음악적으로 상징하는 동기는 무엇인가요?",
      "options": ["리토르넬로", "라이트모티프", "스코르다투라", "트레몰로"],
      "answer": 1,
      "explanation": "바그너는 특정 인물이나 사물을 상징하는 음악 동기인 라이트모티프를 체계적으로 사용했습니다."
    },
    {
      "question": "전통적인 조성 체계의 한계를 극단까지 밀어붙였다고 평가받는 바그너의 혁신적 화성 이름은 무엇인가요?",
      "options": ["기능화음", "트리스탄 화음", "12음 음계", "평균율 화음"],
      "answer": 1,
      "explanation": "'트리스탄 화음'은 전통 조성 체계의 한계를 밀어붙인 화성으로 평가받습니다."
    }
  ],
  "verdi": [
    {
      "question": "주세페 베르디가 활동 초기에 커다란 성공을 거두게 해준 오페라 작품이 아닌 것은 무엇인가요?",
      "options": ["나부코와 리골레토", "일 트로바토레와 라 트라비아타", "아이다와 오텔로", "위에 언급된 모든 곡이 초기 성공작이다"],
      "answer": 2,
      "explanation": "나부코, 리골레토, 일 트로바토레, 라 트라비아타는 초기 성공작이며, 아이다, 오텔로, 팔스타프는 후기 깊어진 세계를 보여주는 작품입니다."
    },
    {
      "question": "주세페 베르디가 오페라를 통해 가장 탁월하게 표현해냈던 음악적 능력은 무엇인가요?",
      "options": ["기계적이고 정교한 대위법의 계산", "인간 심리와 극적 전개의 표현", "새소리의 정밀한 오케스트라 묘사", "동양 철학의 신비로운 이식"],
      "answer": 1,
      "explanation": "베르디는 인간 심리와 극적 전개를 음악으로 표현하는 능력이 뛰어났습니다."
    },
    {
      "question": "주세페 베르디는 음악적 명성 외에도 자국 내에서 어떤 정치/사회적 운동의 상징으로 여겨졌나요?",
      "options": ["프랑스 혁명 운동", "이탈리아 통일 운동", "소련 체제 저항 운동", "체코 독립 운동"],
      "answer": 1,
      "explanation": "베르디는 이탈리아 통일 운동의 상징적 인물로도 여겨졌습니다."
    },
    {
      "question": "베르디가 남긴 후기 오페라의 대표작 세 편은 무엇인가요?",
      "options": ["나부코 - 리골레토 - 라 트라비아타", "아이다 - 오텔로 - 팔스타프", "라 보엠 - 토스카 - 투란도트", "보체크 - 룰루 - 피터 그라임스"],
      "answer": 1,
      "explanation": "후기에는 아이다, 오텔로, 팔스타프로 더욱 깊은 음악 세계를 보여주었습니다."
    },
    {
      "question": "이탈리아 오페라의 최고 거장인 주세페 베르디와 같은 해(1813년)에 태어난 강력한 라이벌 작곡가는 누구인가요?",
      "options": ["프란츠 리스트", "엑토르 베를리오즈", "리하르트 바그너", "요하네스 브람스"],
      "answer": 2,
      "explanation": "1813년생 동갑내기 작곡가로 본문에서 독일 오페라 혁신가로 소개된 인물은 리하르트 바그너입니다."
    }
  ],
  "brahms": [
    {
      "question": "바그너와 리스트의 표제 음악에 맞서 베토벤의 전통을 계승한 '이 진영'의 대표 작곡가는 누구인가요?",
      "options": ["표제 음악 진영", "인상주의 진영", "절대 음악 진영", "무조 음악 진영"],
      "answer": 2,
      "explanation": "요하네스 브람스는 절대 음악 진영의 대표 작곡가입니다."
    },
    {
      "question": "다음 중 요하네스 브람스의 대표작으로 언급되지 않은 작품은 무엇인가요?",
      "options": ["교향곡 4곡", "독일 레퀴엠", "헝가리 무곡", "동물의 사육제"],
      "answer": 3,
      "explanation": "교향곡 4곡, 독일 레퀴엠, 헝가리 무곡은 브람스의 대표작이며 동물의 사육제는 생상스의 곡입니다."
    },
    {
      "question": "브람스가 고전주의 형식을 엄격히 유지하면서도 속에 담아내었던 음악적 감성은 무엇인가요?",
      "options": ["풍부한 낭만주의 감성", "차가운 현대 기계주의 감성", "신비주의적 종교 감성", "원시주의적 타악 감성"],
      "answer": 0,
      "explanation": "브람스는 풍부한 낭만주의 감성을 담으면서도 고전주의 형식을 유지했습니다."
    },
    {
      "question": "브람스가 베토벤의 전통을 위대하게 계승한 덕분에 음악사에서 흔히 불리는 별칭은 무엇인가요?",
      "options": ["교향곡의 아버지", "베토벤의 후계자", "피아노의 시인", "인상주의의 창시자"],
      "answer": 1,
      "explanation": "브람스는 음악사에서 흔히 '베토벤의 후계자'로 불립니다."
    },
    {
      "question": "브람스가 표제 음악에 대응하여 주로 발전시킨 두 가지 핵심 음악 장르는 무엇인가요?",
      "options": ["오페라와 오라토리오", "교향곡과 실내악", "교향시와 악극", "발레 음악과 표제 교향곡"],
      "answer": 1,
      "explanation": "브람스는 베토벤의 전통을 계승해 교향곡과 실내악을 발전시켰습니다."
    }
  ],
  "bruckner": [
    {
      "question": "안톤 브루크너의 음악 세계를 구축하는 데 가장 큰 바탕이 되었던 개인적 배경은 무엇인가요?",
      "options": ["독실한 가톨릭 신앙", "격렬한 혁명 운동 참여", "스페인 민속 음악 연구", "러시아 문학과의 결합"],
      "answer": 0,
      "explanation": "안톤 브루크너는 독실한 가톨릭 신앙을 바탕으로 종교적이고 장엄한 음악 세계를 구축했습니다."
    },
    {
      "question": "다음 중 안톤 브루크너의 교향곡 중 특히 유명하다고 본문에 명시된 번호 조합은 무엇인가요?",
      "options": ["1번, 2번, 3번", "3번, 4번, 5번", "7번, 8번, 9번", "5번, 6번, 7번"],
      "answer": 2,
      "explanation": "브루크너의 교향곡은 7번, 8번, 9번이 특히 유명합니다."
    },
    {
      "question": "브루크너 교향곡의 구조와 악기 사용법의 가장 큰 특징은 무엇인가요?",
      "options": ["극도로 축소된 현악 사중주 구조", "대성당 건축을 연상시키는 거대한 구조와 금관악기의 웅장한 사용", "새소리를 묘사하는 정교한 목관악기 위주의 배치", "피아노 한 대만을 사용하는 미니멀리즘 구조"],
      "answer": 1,
      "explanation": "브루크너 교향곡은 대성당 건축을 연상시키는 거대한 구조와 금관악기의 웅장한 사용이 특징입니다."
    },
    {
      "question": "안톤 브루크너의 거대한 교향곡 양식은 후대 어떤 교향곡 거장에게 큰 영향을 주었나요?",
      "options": ["요하네스 브람스", "구스타프 말러", "이고르 스트라빈스키", "벤저민 브리튼"],
      "answer": 1,
      "explanation": "브루크너의 음악은 말러에게 큰 영향을 주었습니다."
    },
    {
      "question": "안톤 브루크너의 국적은 어디인가요?",
      "options": ["독일", "오스트리아", "프랑스", "체코"],
      "answer": 1,
      "explanation": "안톤 브루크너는 오스트리아의 작곡가입니다."
    }
  ],
  "saintsaens": [
    {
      "question": "카미유 생상스가 남긴 대표작 목록에 포함되지 않은 작품은 무엇인가요?",
      "options": ["동물의 사육제", "교향곡 제3번 오르간", "서주와 론도 카프리치오소", "나의 조국"],
      "answer": 3,
      "explanation": "동물의 사육제, 오르간 교향곡, 서주와 론도 카프리치오소는 생상스의 대표작이며, '나의 조국'은 스메타나의 곡입니다."
    },
    {
      "question": "카미유 생상스가 자신의 음악 속에서 결합해낸 두 가지 예술적 핵심 요소는 무엇인가요?",
      "options": ["무조 음악과 기능화성 이론", "고전적 균형감과 프랑스 특유의 우아함", "러시아적 서정성과 기계적 리듬", "동양 철학과 독창적 리듬 체계"],
      "answer": 1,
      "explanation": "생상스는 고전적 균형감과 프랑스 특유의 우아함을 결합했습니다."
    },
    {
      "question": "카미유 생상스는 어느 나라 낭만주의 음악의 중심 인물이었나요?",
      "options": ["독일", "오스트리아", "프랑스", "러시아"],
      "answer": 2,
      "explanation": "카미유 생상스는 프랑스 낭만주의 음악의 중심 인물입니다."
    },
    {
      "question": "생상스의 대표 교향곡인 '교향곡 제3번'에 특별하게 독주 악기로 추가되어 큰 웅장함을 주는 악기는 무엇인가요?",
      "options": ["피아노", "오르간", "기타", "클라브생"],
      "answer": 1,
      "explanation": "생상스의 대표작 중 하나는 '교향곡 제3번 오르간'입니다."
    },
    {
      "question": "생상스의 음악 스타일을 표현하는 본문 속 문구로 가장 올바른 것은 무엇인가요?",
      "options": ["극단적 화성과 강렬한 표현으로 현대 음악의 문을 열었다", "전통 조성을 파괴하고 새로운 음계를 사용했다", "고전적 균형감과 프랑스 특유의 우아함을 결합했다", "사실적인 인물 묘사와 스페인적 색채를 결합했다"],
      "answer": 2,
      "explanation": "생상스는 고전적 균형감과 프랑스 특유의 우아함을 결합했다는 특징이 명시되어 있습니다."
    }
  ],
  "bizet": [
    {
      "question": "초연 당시 비난받았으나 이후 세계에서 가장 유명하고 자주 상연되는 오페라 중 하나가 된 비제의 대표작은 무엇인가요?",
      "options": ["라 트라비아타", "카르멘", "라 보엠", "살로메"],
      "answer": 1,
      "explanation": "조르주 비제의 대표작은 오페라 '카르멘'입니다."
    },
    {
      "question": "조르주 비제의 오페라 '카르멘'이 지닌 음악적, 극적 서사 특징 두 가지는 무엇인가요?",
      "options": ["그리스 신화의 완벽한 재현과 장엄함", "사실적인 인물 묘사와 강렬한 스페인적 색채", "우연성 음악과 동양 철학의 조화", "초자연적 요소를 결합한 독일 민속 전설"],
      "answer": 1,
      "explanation": "카르멘은 사실적인 인물 묘사와 강렬한 스페인적 색채가 특징입니다."
    },
    {
      "question": "조르주 비제가 세상을 떠났을 때의 나이는 몇 세였나요?",
      "options": ["26세", "31세", "36세", "45세"],
      "answer": 2,
      "explanation": "조르주 비제는 36세의 젊은 나이에 요절했습니다."
    },
    {
      "question": "조르주 비제의 국적은 어디인가요?",
      "options": ["이탈리아", "스페인", "프랑스", "러시아"],
      "answer": 2,
      "explanation": "조르주 비제는 프랑스의 작곡가입니다."
    },
    {
      "question": "비제가 요절했음에도 불구하고 음악사적으로 어떤 분야에 거대한 족적을 남겼다고 평가받나요?",
      "options": ["오르간 음악 역사", "오페라 역사", "피아노 소나타 역사", "바이올린 교본 역사"],
      "answer": 1,
      "explanation": "비제는 요절했지만 오페라 역사에 거대한 족적을 남겼습니다."
    }
  ],
  "tchaikovsky": [
    {
      "question": "다음 중 차이콥스키의 3대 발레 음악 걸작으로 본문에 묶여 언급된 작품이 아닌 것은 무엇인가요?",
      "options": ["백조의 호수", "잠자는 숲속의 미녀", "호두까기 인형", "동물의 사육제"],
      "answer": 3,
      "explanation": "백조의 호수, 잠자는 숲속의 미녀, 호두까기 인형은 차이콥스키의 3대 발레 걸작입니다."
    },
    {
      "question": "차이콥스키가 작곡한 교향곡 중 본문에서 대표작으로 명시한 세 편의 번호는 무엇인가요?",
      "options": ["제1·2·3번", "제3·4·5번", "제4·5·6번 비창", "제7·8·9번"],
      "answer": 2,
      "explanation": "차이콥스키의 대표작으로 교향곡 제4·5·6번 '비창'이 언급되어 있습니다."
    },
    {
      "question": "차이콥스키가 성공적으로 결합해낸 두 가지 음악적 기법과 감성은 무엇인가요?",
      "options": ["서유럽 음악 기법과 러시아적 감성", "이탈리아 오페라와 스페인 리듬", "독일 대위법과 프랑스 인상주의", "미국 민속 선율과 무조 기법"],
      "answer": 0,
      "explanation": "차이콥스키는 서유럽 음악 기법과 러시아적 감성을 성공적으로 결합했습니다."
    },
    {
      "question": "차이콥스키 음악의 가장 강력한 대중적 매력으로 꼽히는 두 가지 특징은 무엇인가요?",
      "options": ["극도로 짧고 응축된 구조", "풍부한 선율과 강렬한 감정 표현", "철저한 규칙과 과학적 이론", "우연성과 기계적인 기법"],
      "answer": 1,
      "explanation": "차이콥스키는 풍부한 선율과 강렬한 감정 표현으로 오늘날 가장 사랑받는 작곡가 중 한 명입니다."
    },
    {
      "question": "차이콥스키는 교향곡 외에 어떤 독주 악기 협주곡들을 대표작으로 남겼나요?",
      "options": ["오르간 협주곡 & 플루트 협주곡", "피아노 협주곡 제1번 & 바이올린 협주곡", "첼로 협주곡 & 클라리넷 협주곡", "기타 협주곡 & 하프 협주곡"],
      "answer": 1,
      "explanation": "대표작으로 피아노 협주곡 제1번과 바이올린 협주곡이 명시되어 있습니다."
    }
  ],
  "smetana": [
    {
      "question": "체코 민족 정체성을 음악으로 표현하여 '체코 민족주의 음악의 아버지'로 불리는 작곡가는 누구인가요?",
      "options": ["베드르지흐 스메타나", "안토닌 드보르자크", "벨라 바르토크", "요한 슈타미츠"],
      "answer": 0,
      "explanation": "베드르지흐 스메타나는 체코 민족주의 음악의 아버지입니다."
    },
    {
      "question": "체코의 강과 자연을 정교하게 묘사한 곡으로 유명한 스메타나의 교향시 연작 제목은 무엇인가요?",
      "options": ["나의 조국", "핀란디아", "바다", "차라투스트라는 이렇게 말했다"],
      "answer": 0,
      "explanation": "스메타나의 대표작은 교향시 연작 '나의 조국'입니다."
    },
    {
      "question": "교향시 연작 '나의 조국' 중에서도 체코의 강과 자연을 아름답게 묘사하여 가장 유명한 단독 곡의 이름은 무엇인가요?",
      "options": ["몰다우", "불새", "마탄의 사수", "디도의 비가"],
      "answer": 0,
      "explanation": "'나의 조국' 중 '몰다우'는 체코의 강과 자연을 묘사한 작품으로 유명합니다."
    },
    {
      "question": "스메타나가 자신의 음악을 통해 궁극적으로 표현하고자 했던 핵심 가치는 무엇인가요?",
      "options": ["독일 프로테스탄트 찬송가의 위대함", "체코 민족 정체성", "스탈린 체제에 대한 찬양", "가톨릭 신앙의 장엄함"],
      "answer": 1,
      "explanation": "스메타나는 체코 민족 정체성을 음악으로 표현했습니다."
    },
    {
      "question": "베드르지흐 스메타나가 주로 곡을 남긴 핵심 관현악 장르는 무엇인가요?",
      "options": ["악극", "오페라 부파", "교향시", "예술 가곡"],
      "answer": 2,
      "explanation": "스메타나는 대표작인 '나의 조국'과 같은 '교향시' 장르를 통해 민족 정체성을 드러냈습니다."
    }
  ],
  "dvorak": [
    {
      "question": "안토닌 드보르자크가 작곡한 교향곡 중 대중적으로 가장 유명한 '제9번'의 별칭은 무엇인가요?",
      "options": ["영웅", "운명", "신세계로부터", "미완성"],
      "answer": 2,
      "explanation": "드보르자크는 교향곡 제9번 '신세계로부터'가 가장 유명합니다."
    },
    {
      "question": "다음 중 드보르자크의 대표작 목록에 교향곡 9번과 함께 명시된 작품 두 편은 무엇인가요?",
      "options": ["슬라브 무곡 & 첼로 협주곡", "헝가리 무곡 & 피아노 협주곡 1번", "동물의 사육제 & 카르멘", "백조의 호수 & 나의 조국"],
      "answer": 0,
      "explanation": "드보르자크의 대표작으로 '슬라브 무곡'과 '첼로 협주곡'이 언급되어 있습니다."
    },
    {
      "question": "드보르자크가 음악 속에서 자연스럽게 결합해낸 두 가지 요소는 무엇인가요?",
      "options": ["무조 음계와 엄격한 대위법", "민속 선율과 고전적 형식", "새소리 연구와 가톨릭 신앙", "전자 음악과 우연성 체계"],
      "answer": 1,
      "explanation": "드보르자크는 민속 선율과 고전적 형식을 자연스럽게 결합했습니다."
    },
    {
      "question": "드보르자크는 체코 외에 어느 나라의 음악 발전에도 큰 영향을 주었나요?",
      "options": ["영국", "프랑스", "미국", "러시아"],
      "answer": 2,
      "explanation": "드보르자크는 미국 음악 발전에도 영향을 주었습니다."
    },
    {
      "question": "안토닌 드보르자크는 체코 민족주의 음악에서 어떤 위치를 차지하고 있나요?",
      "options": ["창시자이자 아버지", "대표 인물", "신고전주의로의 전향자", "최초의 요절 작곡가"],
      "answer": 1,
      "explanation": "드보르자크는 체코 민족주의 음악의 '대표 인물'로 명시되어 있습니다. (아버지는 스메타나)"
    }
  ],
  "mahler": [
    {
      "question": "구스타프 말러가 작곡한 대표 교향곡 목록에 포함되지 않은 작품은 무엇인가요?",
      "options": ["교향곡 제2번 부활", "교향곡 제5번 & 제8번 천인 교향곡", "대지의 노래", "교향곡 제9번 신세계로부터"],
      "answer": 3,
      "explanation": "부활, 제5번, 천인 교향곡, 대지의 노래는 말러의 대표작이며, 신세계로부터는 드보르자크의 곡입니다."
    },
    {
      "question": "말러가 교향곡 속에 담아내고자 했던 철학적인 질문의 주제가 아닌 것은 무엇인가요?",
      "options": ["삶과 죽음", "자연과 우주", "인간 존재", "스페인 투우사의 사실적 묘사"],
      "answer": 3,
      "explanation": "말러는 삶과 죽음, 자연과 우주, 인간 존재에 대한 철학적 질문을 표현했습니다. 투우사 묘사는 비제의 카르멘에 가깝습니다."
    },
    {
      "question": "구스타프 말러의 교향곡들이 지닌 음악사적인 거대한 위치는 어떻게 평가받나요?",
      "options": ["초기 바로크 음악의 완벽한 부활", "후기 낭만주의의 종착점이자 20세기 음악의 출발점", "고전주의 미니멀리즘의 최종 완성", "영국 오페라 부흥의 직접적 선조"],
      "answer": 1,
      "explanation": "그의 교향곡은 후기 낭만주의의 종착점이자 20세기 음악의 출발점으로 평가받습니다."
    },
    {
      "question": "말러는 생전에 작곡가로서보다 '이 직업'으로 훨씬 더 명성을 떨쳤습니다. '이 직업'은 무엇인가요?",
      "options": ["피아노 연주자", "바이올린 교사", "음악 지휘자", "음악 평론가"],
      "answer": 2,
      "explanation": "말러는 생전에 지휘자로 더 유명했으나 현재는 가장 위대한 교향곡 작곡가 중 한 명으로 인정받습니다."
    },
    {
      "question": "말러가 자신의 음악적 지론으로 내세우며 극대화했던 주장(오케스트라 규모 확장 포함)은 무엇인가요?",
      "options": ["교향곡은 아주 짧고 응축되어야 한다", "교향곡은 하나의 세계를 담아야 한다", "교향곡은 절대 문학을 담아서는 안 된다", "교향곡은 피아노 한 대면 충분하다"],
      "answer": 1,
      "explanation": "말러는 '교향곡은 하나의 세계를 담아야 한다'고 주장하며 오케스트라 규모를 극한까지 확장했습니다."
    }
  ],
  "r_strauss": [
    {
      "question": "리하르트 슈트라우스가 완성한 대표 관현악 음악 장르는 무엇인가요?",
      "options": ["악극", "교향시", "오라토리오", "현악 오중주"],
      "answer": 1,
      "explanation": "리하르트 슈트라우스는 교향시 장르를 완성한 작곡가입니다."
    },
    {
      "question": "다음 중 리하르트 슈트라우스의 대표 교향시 작품이 아닌 것은 무엇인가요?",
      "options": ["차라투스트라는 이렇게 말했다", "돈 후안", "영웅의 생애", "나의 조국"],
      "answer": 3,
      "explanation": "차라투스트라, 돈 후안, 영웅의 생애는 슈트라우스의 교향시이며, '나의 조국'은 스메타나의 작품입니다."
    },
    {
      "question": "슈트라우스의 오페라 중, 극단적 화성과 강렬한 표현으로 '현대 음악의 문을 열었다'고 평가받는 두 작품은 무엇인가요?",
      "options": ["피가로의 결혼 & 마술피리", "살로메 & 엘렉트라", "라 보엠 & 투란도트", "보체크 & 룰루"],
      "answer": 1,
      "explanation": "오페라 살로메와 엘렉트라는 극단적 화성과 강렬한 표현으로 현대 음악의 문을 열었습니다."
    },
    {
      "question": "리하르트 슈트라우스가 오케스트라를 이용해 발휘했던 독보적인 음악적 능력은 무엇인가요?",
      "options": ["수학적인 대위법적 선율의 계산", "심리 묘사와 음향 표현", "체제 순응 속에 숨겨진 풍자", "우연성에 기반한 소음의 나열"],
      "answer": 1,
      "explanation": "슈트라우스는 오케스트라를 이용한 심리 묘사와 음향 표현에서 독보적인 능력을 보였습니다."
    },
    {
      "question": "슈트라우스가 후기(말년)에 남긴 작품들의 성향적 특징은 무엇인가요?",
      "options": ["더욱 파격적이고 무조적인 악극만 고집함", "장미의 기사와 같은 보다 전통적인 작품을 남김", "새소리 연구에만 집착함", "피아노 기교주의 음악으로 회귀함"],
      "answer": 1,
      "explanation": "슈트라우스는 후기에 '장미의 기사'와 같은 보다 전통적인 작품도 남겼습니다."
    }
  ],
  "puccini": [
    {
      "question": "이탈리아 오페라의 마지막 거장으로 불리는 자코모 푸치니의 4대 대표작에 포함되지 않는 것은 무엇인가요?",
      "options": ["라 보엠 & 토스카", "나비 부인 & 투란도트", "나부코 & 라 트라비아타", "위에 언급된 네 작품 모두 푸치니의 곡이다"],
      "answer": 2,
      "explanation": "라 보엠, 토스카, 나비 부인, 투란도트는 푸치니의 대표작이며 나부코와 라 트라비아타는 베르디의 곡입니다."
    },
    {
      "question": "자코모 푸치니가 자신의 오페라 속에서 결합해낸 두 가지 핵심 요소는 무엇인가요?",
      "options": ["그리스 신화와 프랑스 인상주의", "베리즈모 오페라의 사실성과 낭만주의적 아름다운 선율", "무조 음악 체계와 기계적 리듬", "독독교 신앙과 거대한 대성당 구조"],
      "answer": 1,
      "explanation": "푸치니는 베리즈모 오페라의 사실성과 낭만주의적 아름다운 선율을 결합했습니다."
    },
    {
      "question": "푸치니 오페라가 지닌 가장 뛰어난 극작 및 음악적 강점은 무엇인가요?",
      "options": ["철저하게 과학적이고 수학적인 화성학 정리", "인간 감정 표현에 탁월함", "악기를 완전히 배제한 순수 성악의 고집", "동양의 선불교 사상 반영"],
      "answer": 1,
      "explanation": "푸치니는 인간 감정 표현에 탁월하여 오늘날 가장 인기 있는 오페라 작곡가로 꼽힙니다."
    },
    {
      "question": "자코모 푸치니의 출신 국가는 어디인가요?",
      "options": ["프랑스", "독일", "오스트리아", "이탈리아"],
      "answer": 3,
      "explanation": "자코모 푸치니는 이탈리아 오페라의 거장입니다."
    },
    {
      "question": "푸치니가 음악사에서 가지는 위상으로 가장 적절한 명칭은 무엇인가요?",
      "options": ["독일 낭만주의 오페라의 창시자", "이탈리아 오페라의 마지막 거장", "영국 현대 오페라의 부흥을 이끈 인물", "최초로 역사적 인물을 다룬 혁신가"],
      "answer": 1,
      "explanation": "푸치니는 '이탈리아 오페라의 마지막 거장'으로 명시되어 있습니다."
    }
  ],
  "debussy": [
    {
      "question": "전통적인 장조·단조 체계에서 벗어나 음악사에서 '인상주의 음악의 창시자'로 평가받는 작곡가는 누구인가요?",
      "options": ["클로드 드뷔시", "모리스 라벨", "올리비에 메시앙", "피에르 불레즈"],
      "answer": 0,
      "explanation": "클로드 드뷔시는 인상주의 음악의 창시자입니다."
    },
    {
      "question": "다음 중 클로드 드뷔시의 대표작 목록에 명시되지 않은 작품은 무엇인가요?",
      "options": ["목신의 오후에의 전주곡 & 바다", "베르가마스크 모음곡 & 달빛", "볼레로 & 거울", "위에 언급된 모든 곡이 드뷔시의 대표작이다"],
      "answer": 2,
      "explanation": "목신의 오후, 바다, 베르가마스크, 달빛은 드뷔시의 대표작이지만, 볼레로와 거울은 라벨의 곡입니다."
    },
    {
      "question": "드뷔시가 자신의 인상주의 음악을 통해 궁극적으로 표현하고자 했던 세 가지 요소는 무엇인가요?",
      "options": ["수학적 규칙, 완벽한 대위법, 대성당 구조", "빛과 색채, 분위기", "스탈린의 압박, 저항, 풍자", "초자연적 전설, 권선징악, 영웅 정신"],
      "answer": 1,
      "explanation": "드뷔시는 빛과 색채, 분위기를 음악으로 표현하려 했습니다."
    },
    {
      "question": "드뷔시의 인상주의 음악은 음악사에서 주로 어떤 시점의 출발점으로 평가받나요?",
      "options": ["17세기 바로크 음악의 실질적 출발점", "19세기 예술 가곡의 실질적 출발점", "20세기 음악의 실질적 출발점", "현대 전자 음악의 실질적 출발점"],
      "answer": 2,
      "explanation": "드뷔시의 음악은 20세기 음악의 실질적 출발점으로 평가받습니다."
    },
    {
      "question": "드뷔시가 혁신을 이루기 위해 과감히 탈피했던 전통 음악의 기본 뼈대는 무엇인가요?",
      "options": ["전통적인 장조·단조 체계", "현악 중심의 오케스트라 편성", "독창과 합창을 사용하는 종교적 형식", "한 악장 소나타 구조"],
      "answer": 0,
      "explanation": "드뷔시는 전통적인 장조·단조 체계에서 벗어나 새로운 음계와 화성 언어를 사용했습니다."
    }
  ],
  "ravel": [
    {
      "question": "드뷔시와 함께 프랑스 인상주의를 대표하며, '정교한 오케스트레이션(관현악법)'으로 매우 유명한 작곡가는 누구인가요?",
      "options": ["엑토르 베를리오즈", "모리스 라벨", "피에르 불레즈", "장 시벨리우스"],
      "answer": 1,
      "explanation": "모리스 라벨은 정교한 오케스트레이션과 세련된 음향 감각으로 유명한 프랑스 인상주의 대표자입니다."
    },
    {
      "question": "다음 중 모리스 라벨의 대표작으로 묶여 언급된 작품들의 조합은 무엇인가요?",
      "options": ["볼레로 - 다프니스와 클로에 - 거울 - 죽은 왕녀를 위한 파반느", "목신의 오후에의 전주곡 - 바다 - 달빛", "동물의 사육제 - 카르멘", "나의 조국 - 신세계로부터"],
      "answer": 0,
      "explanation": "볼레로, 다프니스와 클로에, 거울, 죽은 왕녀를 위한 파반느가 라벨의 대표작으로 명시되어 있습니다."
    },
    {
      "question": "라벨의 인상주의 음악이 드뷔시의 인상주의 스타일과 구별되는 가장 큰 차별점은 무엇인가요?",
      "options": ["전통 조성을 완전히 버리고 12음 기법을 고수함", "인상주의를 바탕으로 하면서도 보다 명확하고 구조적인 음악을 추구함", "민속 음악을 채집하여 원시주의 리듬만을 난사함", "오직 종교 음악과 가톨릭 신앙만을 표현함"],
      "answer": 1,
      "explanation": "라벨은 인상주의를 바탕으로 하면서도 보다 명확하고 구조적인 음악을 추구했습니다."
    },
    {
      "question": "모리스 라벨은 어느 나라의 음악가인가요?",
      "options": ["러시아", "핀란드", "프랑스", "이탈리아"],
      "answer": 2,
      "explanation": "모리스 라벨은 프랑스의 작곡가입니다."
    },
    {
      "question": "라벨의 음악적 재능 중 본문에서 특별히 '세련되었다'고 극찬한 감각은 무엇인가요?",
      "options": ["세련된 음향 감각", "세련된 피아노 교육 감각", "세련된 평론 감각", "세련된 무대 장치 연출 감각"],
      "answer": 0,
      "explanation": "라벨은 정교한 오케스트레이션과 세련된 음향 감각으로 유명합니다."
    }
  ],
  "sibelius": [
    {
      "question": "핀란드 민족주의 음악의 상징이자, 자국의 독립 의식 형성에도 큰 영향을 준 작곡가는 누구인가요?",
      "options": ["장 시벨리우스", "베드르지흐 스메타나", "안토닌 드보르자크", "알렉산드르 스크랴빈"],
      "answer": 0,
      "explanation": "장 시벨리우스는 핀란드 민족주의 음악의 상징적인 존재입니다."
    },
    {
      "question": "장 시벨리우스가 남긴 교향시 중 전 세계적으로 가장 유명한 대표작의 이름은 무엇인가요?",
      "options": ["나의 조국", "핀란디아", "몰다우", "법열의 시"],
      "answer": 1,
      "explanation": "시벨리우스는 교향시 '핀란디아'가 가장 유명합니다."
    },
    {
      "question": "장 시벨리우스가 평생 독자적인 음악 언어를 구축하기 위해 작곡한 교향곡은 총 몇 곡인가요?",
      "options": ["3곡", "4곡", "7곡", "9곡"],
      "answer": 2,
      "explanation": "시벨리우스는 교향곡 7곡을 통해 독자적인 음악 언어를 구축했습니다."
    },
    {
      "question": "시벨리우스가 자신의 음악 속에 가장 핵심적으로 담아내고자 했던 두 가지 핀란드적 요소는 무엇인가요?",
      "options": ["핀란드의 자연과 신화", "핀란드의 대성당 구조와 찬송가", "핀란드의 기계 산업과 과학 기술", "핀란드의 오페라 부파 전통"],
      "answer": 0,
      "explanation": "장 시벨리우스는 핀란드의 자연과 신화를 음악에 담았습니다."
    },
    {
      "question": "시벨리우스의 음악이 자국 역사에 기여한 거대한 사회적 공로는 무엇인가요?",
      "options": ["가톨릭 종교의 대통합 유도", "국가적 독립 의식 형성에 큰 영향", "최초의 피아노 슈퍼스타 발굴", "현대 컴퓨터 음악의 토대 마련"],
      "answer": 1,
      "explanation": "그의 음악은 핀란드의 국가적 독립 의식 형성에도 큰 영향을 주었습니다."
    }
  ],
  "scriabin": [
    {
      "question": "신비주의적 세계관을 음악에 담았으며 후기에는 완전히 독자적인 화성 체계를 개발한 러시아 작곡가는 누구인가요?",
      "options": ["알렉산드르 스크랴빈", "세르게이 라흐마니노프", "표트르 일리치 차이콥스키", "세르게이 프로코피예프"],
      "answer": 0,
      "explanation": "알렉산드르 스크랴빈은 신비주의적 세계관을 음악에 담은 독창적 작곡가입니다."
    },
    {
      "question": "알렉산드르 스크랴빈이 남긴 두 편의 대표적인 핵심 관현악(혹은 피아노) 작품은 무엇인가요?",
      "options": ["불새 & 페트루슈카", "법열의 시 & 프로메테우스", "라 보엠 & 토스카", "시간의 종말을 위한 사중주 & 4분 33초"],
      "answer": 1,
      "explanation": "스크랴빈의 대표작으로는 '법열의 시'와 '프로메테우스' 등이 있습니다."
    },
    {
      "question": "스크랴빈이 활동 초기(초기 생애)에 음악적으로 가장 강력하게 영감을 받고 영향을 받았던 작곡가는 누구인가요?",
      "options": ["요한 제바스티안 바흐", "볼프강 아마데우스 모차르트", "프레데리크 쇼پن", "아르놀트 쇤베르크"],
      "answer": 2,
      "explanation": "스크랴빈은 초기에는 쇼팽의 영향을 받았습니다."
    },
    {
      "question": "스크랴빈의 후기 작품들이 음악사적으로 예고하고 기여했던 거대한 흐름은 무엇인가요?",
      "options": ["고전주의 형식의 엄격한 복원", "조성 해체와 현대 음악의 출발 예고", "프랑스풍 서곡 형식의 완성", "영국 오페라의 완벽한 부흥"],
      "answer": 1,
      "explanation": "그의 후기 작품들은 조성 해체와 현대 음악의 출발을 예고했습니다."
    },
    {
      "question": "알렉산드르 스크랴빈의 음악적 세계관을 정의하는 핵심 단어는 무엇인가요?",
      "options": ["민족주의", "신비주의", "사실주의(베리즈모)", "실용주의"],
      "answer": 1,
      "explanation": "스크랴빈은 '신비주의적 세계관'을 음악에 담은 것으로 가장 잘 알려져 있습니다."
    }
  ],
  "rachmaninoff": [
    {
      "question": "20세기에 활동했음에도 불구하고 음악적으로는 끝까지 이 전통을 유지했던 '후기 낭만주의의 마지막 거장'은 누구인가요?",
      "options": ["알렉산드르 스크랴빈", "세르게이 라흐마니노프", "이고르 스트라빈스키", "벨라 바르토크"],
      "answer": 1,
      "explanation": "세르게이 라흐마니노프는 후기 낭만주의의 마지막 거장입니다."
    },
    {
      "question": "다음 중 라흐마니노프의 대표 협주곡 및 관현악 걸작 목록에 포함되지 않는 작품은 무엇인가요?",
      "options": ["피아노 협주곡 제2번 & 제3번", "교향곡 제2번", "파가니니 주제에 의한 광시곡", "관현악을 위한 협주곡"],
      "answer": 3,
      "explanation": "피아노 협주곡 2·3번, 교향곡 2번, 파가니니 광시곡은 라흐마니노프의 곡이며 '관현악을 위한 협주곡'은 바르토크의 작품입니다."
    },
    {
      "question": "세르게이 라흐마니노프 음악의 가장 뚜렷한 외형적 스타일 특징 두 가지는 무엇인가요?",
      "options": ["극도로 짧고 생략된 음향", "풍부한 선율과 화려한 피아노 기교", "우연성과 소음의 과감한 배열", "금관악기의 웅장한 대성당 구조"],
      "answer": 1,
      "explanation": "라흐마니노프는 풍부한 선율과 화려한 피아노 기교가 특징입니다."
    },
    {
      "question": "라흐마니노프가 끝까지 지키고 유지하고자 했던 음악사적 사조는 무엇인가요?",
      "options": ["바로크 전통", "고전주의 전통", "낭만주의 전통", "무조음악 전통"],
      "answer": 2,
      "explanation": "라흐마니노프는 20세기에 활동했지만 음악적으로는 낭만주의 전통을 끝까지 유지했습니다."
    },
    {
      "question": "세르게이 라흐마니노프의 출신 국가는 어디인가요?",
      "options": ["폴란드", "헝가리", "러시아", "체코"],
      "answer": 2,
      "explanation": "세르게이 라흐마니노프는 러시아 출신의 거장입니다."
    }
  ],

  // ==========================================
  // 4. 현대/20세기 작곡가 (Modernclassical_composer.txt)
  // ==========================================
  "schoenberg": [
    {
      "question": "1000년 이상 지속된 조성 체계를 해체하고 무조 음악과 '12음 기법'을 창시한 현대 작곡가는 누구인가요?",
      "options": ["아르놀트 쇤베르크", "알반 베르크", "안톤 베베른", "이고르 스트라빈스키"],
      "answer": 0,
      "explanation": "아르놀트 쇤베르크는 무조 음악과 12음 기법의 창시자입니다."
    },
    {
      "question": "다음 중 아르놀트 쇤베르크의 대표작으로 본문에 명시된 작품들의 조합은 무엇인가요?",
      "options": ["정화된 밤 - 달에 홀린 피에로", "보체크 - 룰루", "불새 - 봄의 제전", "피터 그라임스 - 전쟁 레퀴엠"],
      "answer": 0,
      "explanation": "쇤베르크의 대표작으로는 '정화된 밤'과 '달에 홀린 피에로' 등이 명시되어 있습니다."
    },
    {
      "question": "쇤베르크가 이끌었던, 현대 음악사에서 가장 중요한 혁신을 감행한 음악가 그룹의 명칭은 무엇인가요?",
      "options": ["피렌체 카메라타", "만하임 악파", "제2 빈악파", "러시아 5인조"],
      "answer": 2,
      "explanation": "쇤베르크는 제2 빈악파의 중심 인물입니다."
    },
    {
      "question": "쇤베르크가 이룩한 가장 위대한 음악사적 혁신은 무엇을 해체한 것인가요?",
      "options": ["현악 오케스트라 편성 체계", "1000년 이상 지속된 조성 체계", "오페라의 무대 연출 방식", "피아노 교육용 교재 체계"],
      "answer": 1,
      "explanation": "쇤베르크는 1000년 이상 지속된 조성 체계를 해체하고 새로운 작곡 원리를 제시했습니다."
    },
    {
      "question": "아르놀트 쇤베르크의 국적은 어디인가요?",
      "options": ["독일", "러시아", "오스트리아", "프랑스"],
      "answer": 2,
      "explanation": "아르놀트 쇤베르크는 오스트리아의 작곡가입니다."
    }
  ],
  "berg": [
    {
      "question": "쇤베르크의 제자이자, 현대 음악과 낭만주의 감성의 연결고리 역할을 했던 오스트리아 작곡가는 누구인가요?",
      "options": ["알반 베르크", "안톤 베베른", "벨라 바르토크", "올리비에 메시앙"],
      "answer": 0,
      "explanation": "알반 베르크는 쇤베르크의 제자로서 현대 음악과 낭만주의 감성의 연결고리 역할을 했습니다."
    },
    {
      "question": "알반 베르크가 남긴 현대 오페라 최고의 걸작 두 편은 무엇인가요?",
      "options": ["피가로의 결혼 & 마술피리", "살로메 & 엘렉트라", "보체크 & 룰루", "피터 그라임스 & 카르멘"],
      "answer": 2,
      "explanation": "알반 베르크의 대표작은 오페라 '보체크'와 '룰루'입니다."
    },
    {
      "question": "알반 베르크의 작곡 스타일을 가장 잘 설명한 특징은 무엇인가요?",
      "options": ["12음 기법을 완전히 거부하고 절대 음악의 전통만 고수함", "12음 기법을 사용하면서도 감정적 표현을 유지함", "새소리를 채보하여 신비주의적 종교관을 투영함", "동양의 선불교 사상을 도입해 우연성을 극대화함"],
      "answer": 1,
      "explanation": "베르크는 12음 기법을 사용하면서도 감정적 표현을 유지했다는 독창성이 있습니다."
    },
    {
      "question": "알반 베르크와 쇤베르크의 관계는 어떠했나요?",
      "options": ["베르크가 쇤베르크의 스승이었다", "베르크가 쇤베르크의 제자였다", "서로 만난 적 없는 라이벌이었다", "같은 오케스트라의 공동 지휘자였다"],
      "answer": 1,
      "explanation": "알반 베르크는 '쇤베르크의 제자'로 명시되어 있습니다."
    },
    {
      "question": "알반 베르크는 음악사에서 어떤 두 가지 상반된 성향의 '연결고리' 역할을 했다고 평가받나요?",
      "options": ["바로크 복잡함과 고전주의 명료함", "현대 음악과 낭만주의 감성", "서유럽 기법과 러시아적 감성", "절대 음악과 표제 음악"],
      "answer": 1,
      "explanation": "베르크는 현대 음악과 낭만주의 감성의 연결고리 역할을 했습니다."
    }
  ],
  "webern": [
    {
      "question": "제2 빈악파의 세 번째 인물로, 극도로 짧고 응축된 작품을 남긴 작곡가는 누구인가요?",
      "options": ["알반 베르크", "안톤 베베른", "세르게이 프로코피예프", "존 케이지"],
      "answer": 1,
      "explanation": "안톤 베베른은 제2 빈악파의 세 번째 인물로 짧고 응축된 작품을 남겼습니다."
    },
    {
      "question": "안톤 베베른이 구사했던 대표적인 현대 음악 양식의 명칭은 무엇인가요?",
      "options": ["인상주의 양식", "갈랑 양식", "점묘주의적 음악 양식", "감정과다 양식"],
      "answer": 2,
      "explanation": "안톤 베베른은 점묘주의적 음악 양식을 남겼습니다."
    },
    {
      "question": "베베른의 점묘주의적 음악 양식은 전후 어떤 현대 음악 사조에 거대한 영향을 주었나요?",
      "options": ["총렬주의", "원시주의", "신고전주의", "베리즈모 사실주의"],
      "answer": 0,
      "explanation": "베베른의 양식은 전후 총렬주의에 큰 영향을 주었습니다."
    },
    {
      "question": "안톤 베베른 작품들의 외형적 가장 큰 구조적 특징은 무엇인가요?",
      "options": ["극한까지 확장된 대규모 관현악 구조", "극도로 짧고 응축된 구조", "화려한 무대 장치와 무용의 결합 구조", "민요를 가사로 사용하는 찬송가 구조"],
      "answer": 1,
      "explanation": "베베른은 극도로 짧고 응축된 작품들을 남긴 것이 특징입니다."
    },
    {
      "question": "안톤 베베른의 출신 국가는 어디인가요?",
      "options": ["독일", "프랑스", "러시아", "오스트리아"],
      "answer": 3,
      "explanation": "안톤 베베른은 오스트리아의 작곡가입니다."
    }
  ],
  "stravinsky": [
    {
      "question": "20세기 전 세계 음악사에 강렬한 '리듬 혁명'을 일으킨 스트라빈스키의 원시주의 최고의 걸작은 무엇인가요?",
      "options": ["불새", "페트루슈카", "봄의 제전", "로미오와 줄리엣"],
      "answer": 2,
      "explanation": "특히 '봄의 제전'은 20세기 음악에 리듬 혁명을 일으킨 작품으로 평가받습니다."
    },
    {
      "question": "다음 중 이고르 스트라빈스키의 3대 대표작으로 본문에 묶여 언급되지 않은 작품은 무엇인가요?",
      "options": ["불새", "페트루슈카", "봄의 제전", "피터와 늑대"],
      "answer": 3,
      "explanation": "불새, 페트루슈카, 봄의 제전은 스트라빈스키의 대표작이며 '피터와 늑대'는 프로코피예프의 작품입니다."
    },
    {
      "question": "스트라빈스키가 초기 원시주의 대작들을 남긴 이후, 중심 인물이 되어 이끌었던 현대 음악 사조는 무엇인가요?",
      "options": ["인상주의 음악", "신고전주의 음악", "총렬주의 음악", "우연성 음악"],
      "answer": 1,
      "explanation": "스트라빈스키는 이후 신고전주의 음악의 중심 인물이 되었습니다."
    },
    {
      "question": "스트라빈스키는 음악사에서 어떤 평가를 받는 인물인가요?",
      "options": ["생전에는 평론가로만 유명했던 지휘자", "음악사에서 가장 영향력 있는 작곡가 중 한 명", "오직 영국에서만 인정받은 독설가", "고전주의 하이든 형식을 완벽히 고수한 보수파"],
      "answer": 1,
      "explanation": "스트라빈스키는 음악사에서 가장 영향력 있는 작곡가 중 한 명이자 20세기 음악의 혁명가로 평가받습니다."
    },
    {
      "question": "이고르 스트라빈스키의 원래 태어난 고국은 어디인가요?",
      "options": ["러시아", "프랑스", "헝가리", "오스트리아"],
      "answer": 0,
      "explanation": "이고르 스트라빈스키는 러시아 출신의 작곡가입니다."
    }
  ],
  "bartok": [
    {
      "question": "벨라 바르토크가 20세기 현대 음악 언어에 녹여내기 위해 직접 발로 뛰며 결합했던 연구 분야는 무엇인가요?",
      "options": ["새소리 음향 연구", "민속 음악 연구", "전자 음향 신디사이저 연구", "동양의 선불교 사상 연구"],
      "answer": 1,
      "explanation": "벨라 바르토크는 20세기 음악과 민속 음악 연구를 결합한 작곡가입니다."
    },
    {
      "question": "다음 중 벨라 바르토크가 직접 돌아다니며 민요를 수집하고 연구한 지역이 아닌 곳은 어디인가요?",
      "options": ["헝가리", "루마니아", "슬로바키아", "스페인"],
      "answer": 3,
      "explanation": "바르토크는 헝가리, 루마니아, 슬로바키아 등지의 민요를 직접 수집했습니다."
    },
    {
      "question": "다음 중 벨라 바르토크의 대표적인 핵심 걸작으로 명시되지 않은 작품은 무엇인가요?",
      "options": ["관현악을 위한 협주곡", "현악 사중주 전곡", "미크로코스모스", "시간의 종말을 위한 사중주"],
      "answer": 3,
      "explanation": "관현악을 위한 협주곡, 현악 사중주 전곡, 미크로코스모스는 바르토크의 대표작이며, '시간의 종말을 위한 사중주'는 메시앙의 곡입니다."
    },
    {
      "question": "바르토크가 현대 음악 언어와 결합해내어 독창성을 인정받은 민속 음악의 두 가지 핵심 요소는 무엇인가요?",
      "options": ["민속 음악의 리듬과 음계", "민속 음악의 가사와 종교 의상", "민속 오케스트라의 금관악기 구조", "민속 무대 장치와 극적 독백"],
      "answer": 0,
      "explanation": "바르토크는 민속 음악의 리듬과 음계를 현대 음악 언어와 결합했습니다."
    },
    {
      "question": "벨라 바르토크의 고국은 어디인가요?",
      "options": ["러시아", "헝가리", "영국", "프랑스"],
      "answer": 1,
      "explanation": "벨라 바르토크는 헝가리 출신의 독창적인 작곡가입니다."
    }
  ],
  "prokofiev": [
    {
      "question": "세르게이 프로코피예프 음악의 가장 도드라지는 두 가지 핵심 스타일 특징은 무엇인가요?",
      "options": ["웅장한 성악 합창과 장엄한 신앙심", "강렬한 리듬과 현대적 감각", "우연성에 기반한 극단적 침묵", "극도로 생략된 점묘주의적 짧은 마디"],
      "answer": 1,
      "explanation": "세르게이 프로코피예프는 강렬한 리듬과 현대적 감각이 특징인 작곡가입니다."
    },
    {
      "question": "다음 중 프로코피예프의 대표작 목록에 명시된 작품들의 조합으로 올바른 것은 무엇인가요?",
      "options": ["피아노 협주곡 제3번 - 로미오와 줄리엣 - 피터와 늑대", "불새 - 페트루슈카 - 봄의 제전", "교향곡 제5번 - 제7번 레닌그라드", "오페라 보체크 - 룰루"],
      "answer": 0,
      "explanation": "프로코피예프의 대표작으로는 피아노 협주곡 3번, 로미오와 줄리엣, 피터와 늑대 등이 있습니다."
    },
    {
      "question": "프로코피예프가 자신의 음악 속에 완벽히 공존시켰던 상반된 두 가지 음악 언어적 성격은 무엇인가요?",
      "options": ["무조 음악의 완벽한 해체와 찬송가", "날카롭고 기계적인 음악 언어와 서정성", "웅장한 금관악기와 대성당 건축 구조", "동양 철학과 새소리의 정밀한 묘사"],
      "answer": 1,
      "explanation": "프로코피예프는 날카롭고 기계적인 음악 언어와 서정성을 동시에 지녔습니다."
    },
    {
      "question": "세르게이 프로코피예프는 어느 나라 현대 음악의 핵심 인물인가요?",
      "options": ["프랑스", "영국", "러시아", "미국"],
      "answer": 2,
      "explanation": "프로코피예프는 20세기 러시아 음악의 핵심 인물입니다."
    },
    {
      "question": "프로코피예프가 남긴 대표작 중, 어린이를 위한 음악 동화 성격을 지닌 유명한 관현악 곡은 무엇인가요?",
      "options": ["미크로코스모스", "피터와 늑대", "로미오와 줄리엣", "봄의 제전"],
      "answer": 1,
      "explanation": "그가 남긴 대표작 중 하나는 '피터와 늑대'입니다."
    }
  ],
  "shostakovich": [
    {
      "question": "소련 시대를 대표하며, 스탈린 체제의 극심한 압박 속에서도 작품 활동을 이어간 교향곡 거장은 누구인가요?",
      "options": ["세르게이 프로코피예프", "드미트리 쇼스타코비치", "이고르 스트라빈스키", "알렉산드르 스크랴빈"],
      "answer": 1,
      "explanation": "드미트리 쇼스타코비치는 스탈린 체제의 압박 속에서 작품 활동을 이어간 소련의 대표 작곡가입니다."
    },
    {
      "question": "다음 중 쇼스타코비치의 대표 교향곡 번호 및 별칭 조합으로 본문에 명시된 것은 무엇인가요?",
      "options": ["교향곡 제3번 영웅 & 제5번 운명", "교향곡 제5번 & 제7번 레닌그라드 & 제10번", "교향곡 제2번 부활 & 제8번 천인", "교향곡 제4번 비창 & 제9번 신세계"],
      "answer": 1,
      "explanation": "쇼스타코비치의 대표 교향곡으로는 제5번, 제7번 '레닌그라드', 제10번이 명시되어 있습니다."
    },
    {
      "question": "쇼스타코비치가 표면적으로는 체제에 순응하면서도 음악 속에 교묘히 숨겨 놓았다고 해석되는 두 가지 코드는 무엇인가요?",
      "options": ["가톨릭 신앙과 찬송가", "풍자와 저항", "새소리와 동양 철학", "우연성과 기계음"],
      "answer": 1,
      "explanation": "쇼스타코비치는 표면적으로 체제에 순응하면서도 음악 속에 풍자와 저항을 숨겨 놓았다는 해석이 많습니다."
    },
    {
      "question": "쇼스타코비치가 교향곡 외에 평생에 걸쳐 전곡을 남긴 대표적인 실내악 장르는 무엇인가요?",
      "options": ["트리오 소나타 전곡", "현악 사중주 전곡", "피아노 소나티네 전곡", "클라브생 모음곡 전곡"],
      "answer": 1,
      "explanation": "대표작으로 교향곡들과 함께 '현악 사중주 전곡'이 언급되어 있습니다."
    },
    {
      "question": "드미트리 쇼스타코비치는 20세기 음악사에서 주로 어떤 거장 중 한 명으로 평가받나요?",
      "options": ["20세기 최고의 교향곡 작곡가", "20세기 최고의 가곡 작곡가", "20세기 최고의 바이올린 교사", "20세기 최고의 무조음악 이론가"],
      "answer": 0,
      "explanation": "쇼스타코비치는 20세기 최고의 교향곡 작곡가 중 한 명으로 평가받습니다."
    }
  ],
  "britten": [
    {
      "question": "헨리 퍼셀 이후 암흑기를 걷던 20세기 영국 음악의 위대한 부흥을 이끈 핵심 인물은 누구인가요?",
      "options": ["헨리 퍼셀", "벤저민 브리튼", "요한 크리스티안 바흐", "존 케이지"],
      "answer": 1,
      "explanation": "벤저민 브리튼은 20세기 영국 음악의 부흥을 이끈 인물입니다."
    },
    {
      "question": "벤저민 브리튼이 남긴 현대 오페라 및 종교 성악 최고의 두 걸작은 무엇인가요?",
      "options": ["피가로의 결혼 & 레퀴엠", "보체크 & 룰루", "피터 그라임스 & 전쟁 레퀴엠", "살로메 & 엘렉트라"],
      "answer": 2,
      "explanation": "브리튼의 대표작은 오페라 '피터 그라임스'와 '전쟁 레퀴엠'입니다."
    },
    {
      "question": "벤저민 브리튼이 현대 오페라를 눈부시게 발전시킬 수 있었던 두 가지 핵심 음악적 강점은 무엇인가요?",
      "options": ["명확한 선율과 뛰어난 극적 감각", "무조 체계와 기계적인 리듬 분석", "새소리의 완벽한 오케스트라 채보", "동양 선불교 사상의 완벽한 이해"],
      "answer": 0,
      "explanation": "브리튼은 명확한 선율과 뛰어난 극적 감각으로 현대 오페라를 발전시켰습니다."
    },
    {
      "question": "벤저민 브리튼은 영국 음악사에서 역사상 '누구' 이후 가장 중요한 영국 작곡가로 평가받나요?",
      "options": ["게오르크 프리드리히 헨델", "헨리 퍼셀", "요한 크리스티안 바흐", "존 케이지"],
      "answer": 1,
      "explanation": "브리튼은 퍼셀 이후 가장 중요한 영국 작곡가로 평가받습니다."
    },
    {
      "question": "벤저민 브리튼의 국적은 어디인가요?",
      "options": ["프랑스", "러시아", "영국", "미국"],
      "answer": 2,
      "explanation": "벤저민 브리튼은 영국의 작곡가입니다."
    }
  ],
  "messiaen": [
    {
      "question": "독실한 가톨릭 신앙과 함께 평생 '이것'을 깊이 연구하여 음악에 반영한 것으로 유명한 프랑스 작곡가는 누구인가요?",
      "options": ["스페인 민속 리듬 연구", "새소리 연구", "동양의 선불교 철학 연구", "스탈린 체제의 저항선전 연구"],
      "answer": 1,
      "explanation": "올리비에 메시앙은 독실한 가톨릭 신앙과 새소리 연구로 유명합니다."
    },
    {
      "question": "다음 중 올리비에 메시앙의 대표작으로 본문에 명시된 두 작품의 조합은 무엇인가요?",
      "options": ["전쟁 레퀴엠 & 피터 그라임스", "시간의 종말을 위한 사중주 & 투랑갈릴라 교향곡", "4분 33초 & 미크로코스모스", "보체크 & 룰루"],
      "answer": 1,
      "explanation": "메시앙의 대표작은 '시간의 종말을 위한 사중주'와 '투랑갈릴라 교향곡'입니다."
    },
    {
      "question": "메시앙이 현대 음악에 거대한 영향을 미칠 수 있었던 독창적인 두 가지 음악 체계는 무엇인가요?",
      "options": ["무조 체계와 12음 변주 법칙", "독창적인 리듬 체계와 음계 사용", "기능화성 이론과 대위법 완벽 통합", "우연성 체계와 소음의 개념 확장"],
      "answer": 1,
      "explanation": "메시앙은 독창적인 리듬 체계와 음계 사용으로 현대 음악에 큰 영향을 주었습니다."
    },
    {
      "question": "올리비에 메시앙은 훗날 전위음악의 거장이 되는 어떤 인물들의 위대한 스승이었나요?",
      "options": ["알반 베르크와 안톤 베베른", "불레즈와 슈톡하우젠", "쇼팽과 브람스", "드뷔시와 라벨"],
      "answer": 1,
      "explanation": "메시앙은 불레즈와 슈톡하우젠의 스승이기도 했습니다."
    },
    {
      "question": "올리비에 메시앙의 출신 국가는 어디인가요?",
      "options": ["영국", "미국", "프랑스", "오스트리아"],
      "answer": 2,
      "explanation": "올리비에 메시앙은 프랑스의 작곡가입니다."
    }
  ],
  "cage": [
    {
      "question": "연주자가 무대 위에서 4분 33초 동안 아무런 소리도 내지 않는 파격적인 현대 음악 작품의 작곡가는 누구인가요?",
      "options": ["존 케이지", "피에르 불레즈", "올리비에 메시앙", "안톤 베베른"],
      "answer": 0,
      "explanation": "대표작 '4분 33초'는 미국 현대 작곡가 존 케이지의 작품입니다."
    },
    {
      "question": "존 케이지가 대표하는 20세기 현대 음악 사조의 핵심 명칭은 무엇인가요?",
      "options": ["신고전주의 음악", "총렬주의 음악", "우연성 음악", "인상주의 음악"],
      "answer": 2,
      "explanation": "존 케이지는 우연성 음악의 대표 인물입니다."
    },
    {
      "question": "존 케이지가 '4분 33초' 등의 실험적 작품들을 통해 세상에 던진 가장 근본적인 질문은 무엇인가요?",
      "options": ["화성을 어떻게 하면 가장 과학적으로 정리할 수 있는가", "음악이란 무엇인가에 대한 근본적 질문", "소련 체제의 압박을 어떻게 이겨낼 것인가", "오케스트라 크레셴도를 어떻게 극대화할 것인가"],
      "answer": 1,
      "explanation": "존 케이지는 음악이란 무엇인가에 대한 근본적 질문을 던졌습니다."
    },
    {
      "question": "존 케이지가 음악의 개념 자체를 확장하는 데 강력하게 정신적 영감을 주었던 타방의 철학 사상은 무엇인가요?",
      "options": ["독일 프로테스탄트 사상", "동양 철학과 선불교의 영향", "프랑스 계몽주의 철학", "가톨릭 절대 신앙"],
      "answer": 1,
      "explanation": "그는 동양 철학과 선불교의 영향을 받아 음악의 개념 자체를 확장했습니다."
    },
    {
      "question": "음악사에서 존 케이지를 평가하는 가장 대표적인 문구는 무엇인가요?",
      "options": ["20세기 가장 보수적이고 규칙적인 작곡가", "20세기 가장 논쟁적인 작곡가 중 한 명", "독일 바로크 음악의 아버지", "피아노 연주 기법을 최초로 개발한 인물"],
      "answer": 1,
      "explanation": "존 케이지는 20세기 가장 논쟁적인 작곡가 중 한 명으로 평가받습니다."
    }
  ],
  "boulez": [
    {
      "question": "전후 현대 전위 음악의 핵심 인물로, 메시앙의 제자이자 프랑스 출신의 이 작곡가는 누구인가요?",
      "options": ["피에르 불레즈", "존 케이지", "벤저민 브리튼", "안톤 베베른"],
      "answer": 0,
      "explanation": "피에르 불레즈는 전후 전위 음악의 핵심 인물입니다."
    },
    {
      "question": "피어르 불레즈가 스승 메시앙과 베베른의 영향을 받아 음악사적으로 크게 발전시켰던 음악 기법은 무엇인가요?",
      "options": ["리토르넬로 기법", "스코르다투라 기법", "총렬주의", "모노디 원칙"],
      "answer": 2,
      "explanation": "피에르 불레즈는 총렬주의를 발전시켰습니다."
    },
    {
      "question": "피에르 불레즈가 음악 이론과 작곡 외에도 세계적인 거장으로서 엄청난 영향력을 행사했던 음악 분야는 무엇인가요?",
      "options": ["바이올린 교육 교재 저술", "오케스트라 지휘 분야", "음악 오페라 대본 문학 집필", "피아노 기교주의 연주"],
      "answer": 1,
      "explanation": "불레즈는 현대 음악 이론과 지휘 분야에서도 큰 영향을 주었습니다."
    },
    {
      "question": "피에르 불레즈가 프랑스 현지에서 설립을 주도하며 전 세계 전자 음악 연구를 선도했던 연구소의 이름은 무엇인가요?",
      "options": ["IRCAM", "카메라타", "만하임 학파 연구소", "산마르코 아카데미"],
      "answer": 0,
      "explanation": "불레즈는 IRCAM 설립을 주도하며 전자 음악 연구를 이끌었습니다."
    },
    {
      "question": "피에르 불레즈가 주도했던 IRCAM 연구소의 핵심 연구 테마는 무엇이었나요?",
      "options": ["독일 민요의 채보 연구", "전자 음악 연구", "그리스 오페라 신화 고증 연구", "고전주의 교향곡 형식 복원 연구"],
      "answer": 1,
      "explanation": "IRCAM은 전자 음악 연구를 이끌었던 핵심 기관입니다."
    }
  ]
};